import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { bookingFormCommon } from "./c005-bookingform-common";
import { bookingFormSubmit } from "./c005-bookingform-submission";
import { bookingFormRedemption } from "./c005-bookingform-redemption";
import { bookingFormInfant } from "./c005-bookingform-infant";
import { wcagOptions } from "./wcag";
import { bookingFormSideTrip } from "./c005-bookingform-sidetrip";
import { adobeDataLayerWrapper } from "./adobeDataLayerMethod";
import {headerContent} from "./c002";


export class bookingFormContent {
	private bcommon = new bookingFormCommon();
	private bookingFormSubmit = new bookingFormSubmit();
	private wcag = new wcagOptions();

	$siteCode: string = '';
	$officeCode: string = '';
	$error:Array<string> = [];

	$instance:any;

	$scope:any                  = $('[data-ibe--book-flight]');
	$scopeMob:any               = $('#mobile-bookflight--container');

	toCityFromCookie:any;

	// value for populating to to location field on from location update complete
	toPrepop:string = null;
	isIbePrepop:boolean = false;
	isIbeSwapLocation:boolean = false;

	// for recent search clicked state to prevent auto focus to the next field with ibe search
	recentSearchActive:boolean = false;
	isUkCitySelectedForIbeSearch: boolean = false;

	enrichAlwaysON: string = $('[data-is-always-on-discount]').attr('data-is-always-on-discount');
	isValidFromLocation: boolean = false;
	isValidToLocation: boolean =false;
	isInAllowedListEnrichOnFrom: boolean = false;
	enrichAlwaysOnCountriesData: any = $('[data-enrich-alwaysOn-countries-Data]').attr('data-enrich-alwaysOn-countries-Data');
	isEligibleEnrichAlwaysOn: boolean=false;
	availableDatesForTravelPassReturn: any= [];
	availableDatesForTravelPassDept: any= [];
	/**
	 * @function nav
	 * Initialize IBE Booking navigation
	 * for navbar ibe only
	 * !!! Global
	 */
	nav(): void {
		let _self = this;
		let $checkIn:any         = $('#check-in--container');
		let $viewBooking:any     = $('#view-booking--container');
		let $flightStatus:any    = $('#flight-status--container');
		let $login:any           = $('#login-container');
		let $loggedin:any        = $('#logged-in-user-menu');
		let $checkInMob:any      = $('#mob-checkin--container');
		let $viewBookingMob:any  = $('#mob-viewbooking--container');
		let $flightStatusMob:any = $('#mob-flightstatus--container');
		let $loginMob:any        = $('#mob-login--container');
		let $loggedinMob: any    = $('#mob-logged-in-user-menu');
		let $mhStay: any         = $('#ibe-stay--container');
		let $mhUpgrade: any      = $('#mhupgrade-in--container');
		let $mholidays: any 	 = $('#mholiday-ibe--container');
		let $flightupgradeMob: any 	 = $('#mob-flightupgrade--container');
		let $flightUpgrade : any = $('#view-upgrade');
		let $ibeNav:any;
		let $paymentMethodOptions :any = $(".payment-method-options");
		if($('.ibe-refresh').length >0) {
			$ibeNav     = $('.desktop #bookingNav');

		} else {
			$ibeNav     = $('#bookingNav');
		}		
		let $ibeNavList:any = $('#bookingNav li a');
		$flightUpgrade.hide(); 
		let $errorValidationGen:any     = $('.error-validation');
		let $bookingFormTitle:any       = $('.booking-form--title');
		let $dateFormTitle:any          = $('.date-form--title');
		let $bookdateSelectorGen:any    = $('.book-date--selector');
		let $couponCodeGen:any          = $('.couponCode');
		let $redemptionLogin:any        = $('.redemption-login .form-group');
		let $moreLinks: any 	 = $('#more-links--container');
		let $enrichHotel:any         = $('#enrich-hotels-container');
		let $enrichHotelMob:any      = $('#mob-enrich-hotels-container');

		// IBE Navigation show/hide detailed container
		$ibeNav.find('.book-flight').on('click', () => {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-flight',
                'componentType': 'tab',
                'componentName': 'Flight Top Menu',
                'componentID': '',
				'attributes': []
            });
			let $fromLocation:any        =   _self.$scope.find('.ibe-from--location');
			let $fromSelectize:any       =   $fromLocation.parent().find('.selectize-control .selectize-input');
			let $toLocation:any          =   _self.$scope.find('.ibe-to--location');
			let $toSelectize:any         =   $toLocation.parent().find('.selectize-control .selectize-input');
			let $mcityToSelectInput:any  =   $('.multi-cityTrip--Container').find('select.mc-to--location');

			let $flightHotelBtn:any = $('.flights-hotel-btn');
			$flightHotelBtn.attr('style', 'display:none !important;');
			// show coupan code
			$('#book-flight--container .couponCode').show();
			$('#book-flight--container .flysiswa-voucher-info').addClass('hide');
			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.book-flight').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
				_self.$scope.find('input[name="cash_miles_type"][value="miles"]').prop('checked', false);
				_self.$scope.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
				_self.$scope.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true).trigger('click');				
			}

			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$login.hide();
			$mholidays.hide();
			$flightUpgrade.hide();
			$loggedin.addClass('hidden');
			$moreLinks.hide();
			$enrichHotel.hide();
			

			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$flightupgradeMob.hide();
			$enrichHotelMob.hide();
			// form stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$dateFormTitle.removeClass('has-error');
			$bookdateSelectorGen.removeClass('has-error');
			$fromSelectize.removeClass('has-error');
			$toSelectize.removeClass('has-error');
			$mcityToSelectInput.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
		});
		// IBE Navigation show/hide detailed container
		$ibeNav.find('.redeem-flight').on('click', () => {
			let $fromLocation:any        =   _self.$scope.find('.ibe-from--location');
			let $fromSelectize:any       =   $fromLocation.parent().find('.selectize-control .selectize-input');
			let $toLocation:any          =   _self.$scope.find('.ibe-to--location');
			let $toSelectize:any         =   $toLocation.parent().find('.selectize-control .selectize-input');
			let $mcityToSelectInput:any  =   $('.multi-cityTrip--Container').find('select.mc-to--location');

			let $flightHotelBtn:any = $('.flights-hotel-btn');
			$flightHotelBtn.attr('style', 'display:none !important;');

			$ibeNav.find('li').removeClass('selected');
			$ibeNav.find('.redeem-flight').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
				_self.$scope.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
				_self.$scope.find('input[name="cash_miles_type"][value="cash"]').prop('checked', false);
				_self.$scope.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).trigger('click');
								
			}

			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$login.hide();
			$mholidays.hide();
			$flightUpgrade.hide();
			$loggedin.addClass('hidden');
			$moreLinks.hide();

			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$flightupgradeMob.hide();
			// form stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$dateFormTitle.removeClass('has-error');
			$bookdateSelectorGen.removeClass('has-error');
			$fromSelectize.removeClass('has-error');
			$toSelectize.removeClass('has-error');
			$mcityToSelectInput.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
		});

		// IBE Navigation show/hide detailed container
		$ibeNav.find('.flysiswa').on('click', () => {
			adobeDataLayer.push('click', {
                'clickName': 'click:tab-click:top-nav-flysiswa',
                'componentType': 'tab',
                'componentName': 'Flight Top Menu',
                'componentID': '',
				'attributes': []
            });
			let $fromLocation:any        =   _self.$scope.find('.ibe-from--location');
			let $fromSelectize:any       =   $fromLocation.parent().find('.selectize-control .selectize-input');
			let $toLocation:any          =   _self.$scope.find('.ibe-to--location');
			let $toSelectize:any         =   $toLocation.parent().find('.selectize-control .selectize-input');
			let $mcityToSelectInput:any  =   $('.multi-cityTrip--Container').find('select.mc-to--location');

			let $flightHotelBtn:any = $('.flights-hotel-btn');
			$flightHotelBtn.attr('style', 'display:none !important;');

			$ibeNav.find('li').removeClass('selected');
			// hide coupan code field
			$('#book-flight--container .couponCode').hide();
			$('#book-flight--container .flysiswa-voucher-info').removeClass('hide');
			$ibeNav.find('.flysiswa').parent().addClass('selected');
			if ($('.enrich-revamp').length > 0) {
				$('.enrich-revamp .enrich-header #mab-bookingnav .navbar-default').removeClass('mholidays-navbar');
				_self.$scope.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false);
				_self.$scope.find('input[name="cash_miles_type"][value="cash"]').prop('checked', false);
				_self.$scope.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).trigger('click');
								
			}

			// desktop stuff
			_self.$scope.show();
			$checkIn.hide();
			$viewBooking.hide();
			$flightStatus.hide();
			$login.hide();
			$mholidays.hide();
			$flightUpgrade.hide();
			$loggedin.addClass('hidden');
			$moreLinks.hide();

			// mobile stuff
			_self.$scopeMob.hide();
			$checkInMob.hide();
			$viewBookingMob.hide();
			$flightStatusMob.hide();
			$loginMob.hide();
			$loggedinMob.hide();
			$mhStay.hide();
			$mhUpgrade.hide();
			$flightupgradeMob.hide();
			// form stuff
			$errorValidationGen.hide();
			$bookingFormTitle.removeClass('has-error');
			$dateFormTitle.removeClass('has-error');
			$bookdateSelectorGen.removeClass('has-error');
			$fromSelectize.removeClass('has-error');
			$toSelectize.removeClass('has-error');
			$mcityToSelectInput.removeClass('has-error');
			$couponCodeGen.removeClass('has-error');
			$redemptionLogin.removeClass('has-error');
			// update OND for flysiswa
			var optionsCabin = document.querySelectorAll(".cabin-class .selectize-dropdown-content .option");
			var values = $.map(optionsCabin, function (option: any) {
			if (option.dataset.value != "CFFECO") {
				option.classList.add("hidden");
			}
			});
			let $cabinClass: any = $('.cabin-class');
			$cabinClass[0].selectize.setValue("CFFECO");
			const path = window.location.pathname;
			const flysiswaValue = $('#onlyShowFlysiswa').val();
			if (path.indexOf('student-portal') > 0 && flysiswaValue == 'true') {
				$('.book-flight').css('display', 'none');
				$('.view-booking').css('display', 'none');
				$('.check-in').css('display', 'none');
				$('.flight-status').css('display', 'none');
				$('#bookingNav .nav.navbar-nav').css('justify-content', 'left');
			}
			_self.bcommon.updateMOTAirportList($(_self.$instance), '.ibe-from--location', '.ibe-to--location');
			// hiding tabs manually 
		});

		// IBE Nav click to load OND as per the request from 27932 ticket no.
		$ibeNavList.click(function (event: any) {
			if (!event.currentTarget.classList.contains('flysiswa')) {
				$('.flysiswa-voucher-info .click-to-reveal').html('click to reveal');
				$('.flysiswa-voucher-info .click-to-reveal').removeClass('has-error')
			}
			if (event.currentTarget.classList.contains('book-flight')) {
				if (_self.isMHExplorer()) {
					// here using MOT method but it will update flight OND
					var optionsCabin = document.querySelectorAll(".cabin-class .selectize-dropdown-content .option");
					var values = $.map(optionsCabin, function (option: any) {
						option.classList.remove("hidden");
					});
					let $cabinClass: any = $('.cabin-class');
					$cabinClass[0].selectize.setValue("CFFECO");
				}
					_self.bcommon.updateMOTAirportList($(_self.$instance), '.ibe-from--location', '.ibe-to--location');
			}
		})

		// Enrich always on only for cash flow	
		$paymentMethodOptions.find('input[name="cash_miles_type"]').on('click', () => {
			_self.isEligibleEnrichAlwaysOn=false;
			_self.showEnrichAlwaysOnBanner();
		});

		const getCookie = (name: any) => {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) return parts.pop().split(';').shift();
		};

		// hide show flysiswa subsidy tab
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			// show flysiswa tab
			if ($ibeNav.find('.flysiswa-tab') && getCookie('isFlysiswaUser') === 'true') {
				$ibeNav.find('.flysiswa-tab').removeClass('hide');
				let voucherCodeEle = $('#book-flight--container').find('.flysiswa-voucher-code');
				voucherCodeEle.html(getCookie('voucherCode'));
			}
		}
		// for revealing voucher code
		$('.flysiswa-voucher-info .click-to-reveal').click(function () {
			let flyerID = getCookie('flyerID');
			let enrichId = flyerID.slice(2);
			let data = {
				enrichId: enrichId,
				voucherCode: getCookie('voucherCode')
			}
			$.ajax({
				type: 'POST',
				url:'/bin/services/new/mhexplorer/flysiswa/showVoucherInfo',
				data: data,
				success: function(msg:any) {
					var json = null;
					if (typeof msg === 'string') {
						json = JSON.parse(msg);
					} else {
						json = msg;
					}
					if (json.status === "OK") {
						$('.flysiswa-voucher-info .click-to-reveal').html(json.pinCode);
					} else {
						$('.flysiswa-voucher-info .click-to-reveal').addClass('has-error')
						$('.flysiswa-voucher-info .click-to-reveal').html('Data is not available');
					}
				},
				error: function(error:any) {
					$('.flysiswa-voucher-info .click-to-reveal').addClass('has-error')
					$('.flysiswa-voucher-info .click-to-reveal').html('Something went wrong.');
				}
			});
		});

	}
	//checking for MH explorer page
	isMHExplorer():boolean{
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if (studentEnrichIdCookieVal != null && studentDashboard != null) {
			return true;
		}
		else{
			return false
		}
	}
	showEnrichAlwaysOnBanner():void{
		let _self=this;
		let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
		let cashFlowType = $('input[name="cash_miles_type"]:checked').val();
		let $tripType =	$('.trip-type--container li.selected a').attr('data-triptype');
	
		if (!loginTokenCookieVal && _self.enrichAlwaysON=='true'&& !_self.isMHExplorer() && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
			$(".enrichOnDiscountInformation").removeClass('hideclass');
			$(".enrichOnDiscountToggleContainer").addClass('hideclass');

		}
		else if(_self.isEligibleEnrichAlwaysOn && loginTokenCookieVal && _self.enrichAlwaysON=='true' &&  !_self.isMHExplorer() && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
			$(".enrichOnDiscountInformation").addClass('hideclass');
			$(".enrichOnDiscountToggleContainer").removeClass('hideclass');
		}
		else {
			$(".enrichOnDiscountInformation").addClass('hideclass');
			$(".enrichOnDiscountToggleContainer").addClass('hideclass');	
		}
	}
	init(): void { 
		let _self = this;

		let $ibeNav:any;
		if($('.ibe-refresh').length >0) {
			$ibeNav     = $('.desktop #bookingNav');
		}
		else {
			$ibeNav     = $('#bookingNav');
		}
		
		let $desktopIbe:any = $('.desktop#mab-bookingnav');

		let $passengerDetails:any       = $('[data-booking-passenger-details]');
		let $passengerDetailsActive:any = $('[data-booking-passenger-details-selected]');

		const topNavIbe = $('.desktop#mab-bookingnav [data-ibe--book-flight]');
		// hide all passenger fields on load
		$passengerDetailsActive.hide();
		$passengerDetails.addClass('passenger-focused');
		$passengerDetails.show();
		$passengerDetails.find('.total-passengers').show();

		// if page type == homepage
		// hide top ibe only 
		// check for flysiswa variable in URL
		const path = window.location.pathname;
		const flysiswaValue = $('#onlyShowFlysiswa').val();
		if (path.indexOf('student-portal') > 0 && flysiswaValue == 'true') {
			setTimeout(function() {
				$ibeNav.find('.flysiswa').trigger('click');
				$('.flysiswa-tab').addClass('selected');
			}, 500)
		} else {
			if ($('body').hasClass('home')) {
				topNavIbe.show();
				$ibeNav.find('.book-flight').parent().addClass('selected');
			} else {
				topNavIbe.hide();
				$ibeNav.find('.book-flight').parent().removeClass('selected');
			}
		}
		// set z-index of ibe bar so that it supercedes the rest of the standalone ibes appearing on the page later
		$desktopIbe.closest('.container')
			.css({'z-index': 600})
			.attr({'data-component': 'c005'});

		// also set z-index of navbar so that it shows when not expanded (mobile)
		$('.mobile#mab-bookingnav').find('.mobile-ibe.navbar')
			.css({'z-index': 600});

		if (window.location.href.split('/')[3] == 'uk'){
			$('.multicity-promo-text').show();
		}

		// // checking whether user logged and enrich Always on configured onload
		_self.showEnrichAlwaysOnBanner();
		// Enrich always on only for cash flow

		// _self.$scope.find('input[name="cash_miles_type"]').off().on('click', (e:any) => {
		// 	_self.isEligibleEnrichAlwaysOn=false;
		// 	_self.showEnrichAlwaysOnBanner();
		// });
	}

	/**
	 * @function closeIbeHandler
	 * for navbar ibe only
	 */
	closeIbeHandler(): void {
		let _self = this;
		let $ibeNavList:any = $('#bookingNav li');
		let $closeIbe:any   = $('.close-booking');
		let ibeClicked:boolean = false;

		// IBE Close detailed container
		$closeIbe.on('click', (e:any) => {
			// clear error on closing form
			// find out which form is being closed and switch to function for clearing error messages
			// - clear all error classes
			// - empty error summary
			let $whichForm:string = $(e.target).closest('.ibe-form--container')[0].id;

			switch($whichForm) {
				case 'book-flight--container': {
					let $errorEls = _self.$scope.find('.has-error');
					let $errorValidation = _self.$scope.find('.error-validation').first();

					$errorValidation.hide().find('.mobile-validation--content').empty();
					$errorEls.each(function(){
						$(this).removeClass('has-error');
					});
				}
				break;
				case 'mobile-bookflight--container': {
					let $errorEls = _self.$scopeMob.find('.has-error');
					let $errorValidation = _self.$scopeMob.find('.error-validation').first();

					$errorValidation.hide().find('.mobile-validation--content').empty();
					$errorEls.each(function(){
						$(this).removeClass('has-error');
					});

					// reset to show return tripflow by default
					let bdsRetTrip: any = _self.$scopeMob.find('.book-date--selector.returnTrip');
					let bdsOneTrip: any = _self.$scopeMob.find('.book-date--selector.oneWayTrip');

					bdsRetTrip.show();
					bdsOneTrip.hide();
					if ($('.enrich-revamp').length > 0) {
						$('.enrich-revamp .enrich-header').removeClass('hide');	
						$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
						$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
						$('.enrich-revamp .enrich-home-container').addClass('hide');
						$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');
						if (window.innerWidth < 768) {
							$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
							$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');					
						}		
					}
				}
				break;
				case 'check-in--container': {
					// todo: error clearing on submission
				}
				break;
				case 'mob-checkin--container': {
					// todo: error clearing on submission
					if ($('.enrich-revamp').length > 0) {
						$('.enrich-revamp .enrich-header').removeClass('hide');	
						$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
						$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
						$('.enrich-revamp .enrich-home-container').addClass('hide');
						$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');	
						if (window.innerWidth < 768) {
							$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
							$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');					
						}					
					}
				}
				break;
				case 'view-booking--container': {
					// todo: error clearing on submission
				}
				break;
				case 'mob-viewbooking--container': {
					// todo: error clearing on submission
					if ($('.enrich-revamp').length > 0) {
						$('.enrich-revamp .enrich-header').removeClass('hide');	
						$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
						$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
						$('.enrich-revamp .enrich-home-container').addClass('hide');
						$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');	
						if (window.innerWidth < 768) {
							$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
							$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');					
						}					
					}
				}
				break;
				case 'flight-status--container': {
					// todo: error clearing on submission
				}
				break;
				case 'mob-flightstatus--container': {
					// todo: error clearing on submission
					if ($('.enrich-revamp').length > 0) {
						$('.enrich-revamp .enrich-header').removeClass('hide');	
						$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
						$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
						$('.enrich-revamp .enrich-home-container').addClass('hide');
						$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');	
						if (window.innerWidth < 768) {
							$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
							$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');					
						}
					}
				}
				break;				
				default:
					if ($('.enrich-revamp').length > 0) {
						$('.enrich-revamp .enrich-header').removeClass('hide');	
						$('.enrich-revamp .enrich-sub-home-container').removeClass('hide');	
						$('.enrich-revamp .enrich-footer-container').removeClass('hidden-xs');
						$('.enrich-revamp .enrich-home-container').addClass('hide');
						$('.enrich-revamp .enrich-mobile-ibe-container').addClass('hide');
						if (window.innerWidth < 768) {	
							$('.enrich-revamp .enrich-subhome-static-head').removeClass('hide');
							$('.enrich-revamp .enrich-header .header-wrapper').addClass('enrich-subhome-header-wrapper');					
						}
					}
				break;
			}
			//console.log();

			// specifically target navbar ibes only
			let $ibeNotLoggedIn = $('.desktop#mab-bookingnav .ibe-form--container:not(.user-account-menu), .mobile#mab-bookingnav .ibe-form--container:not(.user-account-menu)');
			$ibeNotLoggedIn.hide();
			$ibeNavList.removeClass('selected');
		});

		$(document).click(function(e: any) {
			if (!ibeClicked && !($("#ui-datepicker-div").datepicker( "widget" ).is(":visible")) && !($.magnificPopup.instance.isOpen) && $('.cabin-class').attr('data-ibeclicked') != 'true' && $('#mob-flightstatus--container .status-from--location').attr('data-ibeclicked') != 'true' &&  $('#flight-status--container').css('display') != 'block' && $('.ibe-refresh').length == 0 ) {
				let $ibeNavList:any = $('#bookingNav li');
				if(!$(e.target).is('#ibeWrapper')) {
					let $ibeNotLoggedIn = $('.desktop#mab-bookingnav .ibe-form--container:not(.user-account-menu), .mobile#mab-bookingnav .ibe-form--container:not(.user-account-menu)');
					$ibeNotLoggedIn.hide();
					$ibeNavList.removeClass('selected');
				}
			}
			ibeClicked = false; 	   
		});
	if ($(".mfp-ready").length > 0)
	{
		ibeClicked = true;
	}
			$('#ibeWrapper, #ibeMobWrapper, #bookingNav, #navbarNav, #mobile-location-popup, #mobile-to-location-popup, #fs-from-location-popup, #fs-to-location-popup').click(function(e: any) {
			ibeClicked = true;
		});

		$(document).on('click', '.mab-nav--overlay, .ui-datepicker-next,.ibe-freesidetrip_popup,.ui-datepicker-prev, .ui-datepicker-close, .alert-row-container, .mobileapp, .container--main-header, .cc-window, .ui-datepicker, .enrich-header', function () {
			ibeClicked = true; 
		});
	}

	/**
	 * @function setInstance
	 * - set current booking form instance
	 * @param {any} obj - current form object
	 * !!! Properly scoped
	 */
	setInstance(obj:any) {
		let _self = this;
		return _self.$instance = $(obj);
	}

	/**
	 * @function getInstance
	 * retrieve currently assigned booking form instance
	 * @return {any} - current instance
	 */
	getInstance():any {
		let _self = this;
		return;
	}

		/**
	 * @function ibePrelod
	 * Preload trip flow static asset when user click on ibe widget
	 * @return {any} - current instance
	 */
	// ibePreload():any {
	// 	var urlLang='en';
	// 	//let dx:any;
	// 	var curSite = window.location.href.split('/')[4];
	// 	if (curSite) {
	// 	  var urlLang = curSite;
	// 	  if(curSite.indexOf(".") > -1) {
	// 		urlLang = curSite.substring(0,curSite.indexOf("."));
	// 	  } 
	// 	}
	// 	if(urlLang =='en'){
	// 		urlLang = "GB";
	// 	}
	// 	else if(urlLang == 'zh_CN' || urlLang =='zh_HK'){
	// 		urlLang = "cn";
	// 	}
	// 	var scriptIbePreload = document.createElement("script");
	// 	scriptIbePreload.addEventListener("load", function(event) {
	// 		$(function() {
	// 			var getUrl = window.location;
	// 			if(getUrl.host == 'www.malaysiaairlines.com'){
	// 				var preloadUrl =   {
	// 					"statics": [{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/amadeus-booking-prod.css",
	// 						"type": "link"
	// 					},
	// 					{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/dx-responsive-prod.css",
	// 						"type": "link"
	// 					},
	// 					{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/customMH.js",
	// 						"type": "script"
	// 					},
	// 					{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/customMH_Merci.js",
	// 						"type": "link"
	// 					}
	// 					]
	// 				}
	// 			}else{
	// 				var preloadUrl =   {
	// 					"statics": [{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/amadeus-booking.css",
	// 						"type": "link"
	// 					},
	// 					{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/dx-responsive.css",
	// 						"type": "link"
	// 					},
	// 					{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/customMH_staging.js",
	// 						"type": "script"
	// 					},
	// 					{
	// 						"src": "https://mab-amadeus-dx-v2.netlify.com/customMH_Merci_staging.js",
	// 						"type": "link"
	// 					}
	// 					]
	// 				}
	// 			}

	// 			if (typeof dx !== "undefined") {
	// 				dx.preload(preloadUrl);
	// 				}

	// 		});
	// 	});
	// 	scriptIbePreload.src = "//wav.ap5.amadeus.com/plnext/MASAirways/Preload.action?LANGUAGE="+urlLang+"&SITE=J03UJ03U";
	// 	scriptIbePreload.async = true;
	// 	scriptIbePreload.type = "text/javascript";
	// 	document.getElementsByTagName('body')[0].appendChild(scriptIbePreload);
	// }

	/**
	 * @function ibeTripType
	 * IBE trip type container
	 * !!! Properly scoped
	 */
	ibeTripType(): void {
		let _self = this;

		let $infantAlertContainer:any = $('#infant-alert--container');
		let $warningAccepted:any = $infantAlertContainer.find('input[name="infant_warning"]');

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		let returnDate = '';

		// return trip click event (desktop)
		curInstance.find('.trip-type--container .returnTrip').click(function(){
			setTimeout(function() {
				_self.DesktopSiteTripButtonDisplay('return');
			}, 1000);

			returnTripClickHandler(this, curInstance);
		// add Enrich Always on	

		});

		// one way trip click event (desktop)
		curInstance.find('.trip-type--container .oneWayTrip').click(function(){
			setTimeout(function() {
				_self.DesktopSiteTripButtonDisplay('oneWay');
			}, 1000);
			oneWayTripClickHandler(this, curInstance);
		});

		// side trip click event (desktop)
		curInstance.find('.trip-type--container .ibe_sideTrip').click(function(){
			//sideTripClickHandler(this, curInstance);
		let ieversion = new headerContent();
		ieversion.checkIEVersion_disablePupup();
		});

		// return trip click event (desktop)
		_self.$instance.find('.trip-type--container .returnTrip').off('click.triptype').on('click.triptype', () =>{
	
			returnTripClickHandler(this, curInstance);
		});

		// one way trip click event (desktop)
		_self.$instance.find('.trip-type--container .oneWayTrip').off('click.triptype').on('click.triptype', () =>{
			
			oneWayTripClickHandler(this, curInstance);
		});

		// multi trip click event (desktop)
		_self.$instance.find('.trip-type--container .multiCityTrip').off('click.triptype').on('click.triptype', () =>{
			$('.ibe_freesidetrip').hide();
			$(".container.location-container.desktop-flight-widget.single-cityTrip--Container").attr("style", "display:none !important;");
			multiTripClickHandler(this, curInstance);
		});
		_self.$instance.find('.trip-type--container .roundTheWorldTrip').off('click.triptype').on('click.triptype', () =>{
			curInstance.find('.trip-type--container').find('li').removeClass('selected');
			curInstance.find('.trip-type--container').find('li.roundTheWorldTrip').addClass('selected');
						if(curInstance.find('.ibe_freesidetrip').is(":visible")) {
				curInstance.find('.ibe_freesidetrip').hide();					
				curInstance.find('.single-city--bookflight').show();
			}

		});
		_self.$instance.find('.trip-type--container .ibe_sideTrip').click(function(){
		let ieversion = new headerContent();
		ieversion.checkIEVersion_disablePupup();			
		$('.trip-sidetrip-container .returnsideTrip').addClass('selected');
		$('.trip-sidetrip-container .oneWaysideTrip').removeClass('selected');
		$(".book-date--selector.returnsideTrip").show();
		$(".book-date--selector.oneWaysideTrip").hide();
        let isedge = navigator.userAgent.indexOf("Edge") > -1;		
		let isexplorer= typeof document !== 'undefined' && !!(document as any).documentMode && !isedge;
		if( isedge ) 
		{
		$(".ibe-freesidetrip_deskp .ibe-sidetrip-container").css({"display": "inline-block", "padding-left":"25%"});
		$(".ibe-freesidetrip_deskp .validation--error-list").css("display", "inline-block");
		}
		else if(isexplorer) 
		{
		$(".ibe-freesidetrip_deskp .ibe-sidetrip-container").css({"display": "inline-block", "padding-left":"25%"});
		$(".ibe-freesidetrip_deskp .validation--error-list").css("display", "inline-block");
		$(".ibe-freesidetrip_deskp .single-sideTrip--Container").css("padding", "0");
		$(".ibe-freesidetrip_deskp .search-container").css("padding", "0");
		}

		if(_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
		_self.$instance.find('.ibe_freesidetrip').hide();					
		_self.$instance.find('.single-city--bookflight').show();
		}

		});
		$('.trip-type--container .ibe_sideTrip').magnificPopup({
			type: 'inline',
			fixedContentPos:'true',
			midClick: true,
			modal:'true',
			closeBtnInside:false,
			showCloseBtn:false,
			mainClass: 'mfp-fade',
			alignTop : true,
			overflowY:'scroll'
		});
		/*
		* return trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function returnTripClickHandler(el:any, instance:any) {
			let singleTripSubmitBtn:any = instance.find('.single-city--bookflight');
			let multiTripSubmitBtn:any  = instance.find('.multi-city--bookflight');
			let rdmSingleSubmitBtn:any = instance.find('.redemption-submit-btn-single');
			let rdmMultiSubmitBtn:any  = instance.find('.redemption-submit-btn-multi');
			let returnTripDepartureDate:any = instance.find('.departureDate');

			// clear select state on all trip type selectors
			instance.find('.trip-type--container').find('li').removeClass('selected');
			instance.find('.trip-type--container').find('li.returnTrip').addClass('selected');

			// toggle display of OnD fields
			instance.find('.book-date--selector.returnTrip').show();
			instance.find('.book-date--selector.oneWayTrip').hide();
			instance.find('.single-cityTrip--Container').show();
			instance.find('.multi-cityTrip--Container').hide();

			// show coupon code field (hide if cug)
			instance.find('.couponCode').show();

			// show redemption payment methods
			instance.find('input[name="cash_miles_type"][value="miles"]').parent().fadeIn(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').parent().fadeIn(300);

			// remove filled state on input labels
			// instance.find('.dep-title').removeClass('input-filled');
			// instance.find('.ret-title').removeClass('input-filled');

			// empty input field
			//instance.find('.departureDate').val('');
			//instance.find('.returnDate').val('');
			if (returnDate != '') {
				instance.find('.returnDate').val(returnDate);
			}
			// toggle single/multi booking state
			instance.find('.search-container').removeClass('multiCityActive');

			// toggle display of submit buttons
			singleTripSubmitBtn.show();
			multiTripSubmitBtn.hide();
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();

			// reset infant warning state on changing triptype
			$warningAccepted.val('');
			if(instance.find('.ibe_freesidetrip').is(":visible")) {
				instance.find('.ibe_freesidetrip').hide();					
				instance.find('.single-city--bookflight').show();
			}

			// Retain the departure date set for single trip
			// returnTripDepartureDate.datepicker('setDate', $('#oneWayTripDateSelector').find('.departureDate').val()).trigger('blur', 'input');
			if ($("#travel_pass").length > 0) {
				instance.find('.travel-pass-info-oneway').addClass('hide');
				instance.find('.travel-pass-info-return').removeClass('hide');
			}
			_self.showEnrichAlwaysOnBanner()
		}

		/**
		* one way trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function oneWayTripClickHandler(el:any, instance:any) {
			let singleTripSubmitBtn:any = instance.find('.single-city--bookflight');
			let multiTripSubmitBtn:any  = instance.find('.multi-city--bookflight');
			let rdmSingleSubmitBtn:any = instance.find('.redemption-submit-btn-single');
			let rdmMultiSubmitBtn:any  = instance.find('.redemption-submit-btn-multi');
			let oneWayTripDepartureDate = instance.find('.departureDate');

			// clear select state on all trip type selectors
			instance.find('.trip-type--container').find('li').removeClass('selected');
			instance.find('.trip-type--container').find('li.oneWayTrip').addClass('selected');

			// toggle display of OnD fields
			instance.find('.book-date--selector.returnTrip').hide();
			instance.find('.book-date--selector.oneWayTrip').show();
			instance.find('.single-cityTrip--Container').show();
			instance.find('.multi-cityTrip--Container').hide();

			// show coupon code field
			instance.find('.couponCode').show();

			// show redemption payment methods
			instance.find('input[name="cash_miles_type"][value="miles"]').parent().fadeIn(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').parent().fadeIn(300);

			// remove filled state on input labels
			// instance.find('.dep-title').removeClass('input-filled');
			// instance.find('.ret-title').removeClass('input-filled');

			// empty input field
			//instance.find('.departureDate').val('');
			//instance.find('.returnDate').val('');
			returnDate = instance.find('.returnDate').val();
			instance.find('.returnDate').val('');
			// toggle single/multi booking state
			instance.find('.search-container').removeClass('multiCityActive');

			// toggle display of submit buttons
			singleTripSubmitBtn.show();
			multiTripSubmitBtn.hide();
			rdmSingleSubmitBtn.show();
			rdmMultiSubmitBtn.hide();

			// reset infant warning state on changing triptype
			$warningAccepted.val('');
			if(instance.find('.ibe_freesidetrip').is(":visible")) {
				instance.find('.ibe_freesidetrip').hide();					
				instance.find('.single-city--bookflight').show();
			}

			// Retain the departure date selected for return trip
			// oneWayTripDepartureDate.datepicker('setDate', $('#returnTripDateSelector').find('.departureDate').val()).trigger('blur', 'input');
			if ($("#travel_pass").length > 0) {
				instance.find('.travel-pass-info-return').addClass('hide');
				instance.find('.travel-pass-info-oneway').removeClass('hide');
			}
			_self.showEnrichAlwaysOnBanner()
		}

		/**
		* one way trip event handler
		* @param {any} el    [target element]
		* @param {any} instance [element parent instance]
		*/
		function multiTripClickHandler(el:any, instance:any) {
			let singleTripSubmitBtn:any = instance.find('.single-city--bookflight');
			let multiTripSubmitBtn:any  = instance.find('.multi-city--bookflight');
			let rdmSingleSubmitBtn:any = instance.find('.redemption-submit-btn-single');
			let rdmMultiSubmitBtn:any  = instance.find('.redemption-submit-btn-multi');

			// clear select state on all trip type selectors
			instance.find('.trip-type--container').find('li').removeClass('selected');
			instance.find('.trip-type--container').find('li.multiCityTrip').addClass('selected');

			// toggle display of OnD fields
			instance.find('.single-cityTrip--Container').hide();
			instance.find('.multi-cityTrip--Container').show();

			// hide coupon code (no coupon available for multicity)
			instance.find('.couponCode').hide();

			// hide redemption payment method and uncheck it
			instance.find('input[name="cash_miles_type"][value="miles"]').prop('checked', false).parent().fadeOut(300);
			instance.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', false).parent().fadeOut(300);
			instance.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true);

			// remove filled state on input labels
			// instance.find('.dep-title').removeClass('input-filled');
			// instance.find('.ret-title').removeClass('input-filled');

			// empty input field
			//instance.find('.departureDate').val('');
			//instance.find('.returnDate').val('');

			// toggle single/multi booking state
			instance.find('.search-container').addClass('multiCityActive');

			// toggle display of submit buttons
			singleTripSubmitBtn.hide();
			multiTripSubmitBtn.show();
			rdmSingleSubmitBtn.hide();
			rdmMultiSubmitBtn.show();

			// reset infant warning state on changing triptype
			$warningAccepted.val('');
			if ($("#travel_pass").length > 0) {
				instance.find('.travel-pass-info-return').addClass('hide');
				instance.find('.travel-pass-info-oneway').addClass('hide');
			}
			_self.showEnrichAlwaysOnBanner()
		}
	
	}

	/**
	 * @function passengerType
	 * IBE Passenger type container
	 * !!! Properly scoped
	 */
	passengerType(): void {
		let _self = this;
		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)');
		let $passengerDetails:any       = _self.$instance.find('[data-booking-passenger-details]');
		let $passengerDetailsActive:any = _self.$instance.find('[data-booking-passenger-details-selected]');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		
		$passengerDetails.on('click', () => {
			$(this).hide();
			$passengerDetailsActive.show();
			curInstance.find('.book-date--selector').removeClass('datepicker-selected');
		});

		$passengerDetailsActive.mouseleave(() => {
			$(this).hide();
			$passengerDetailsActive.hide();
			$passengerDetails.addClass('passenger-focused');
			$passengerDetails.show();
			$passengerDetails.find('.total-passengers').show();
		});

		$passengerDetailsActive.on('touchend', function(e:any) {
			if (!($(e.target).closest('.booking-person').length || $(e.target).is('.booking-person'))) {
			$passengerDetailsActive.hide();
			return false;
			} else {
				return true;
			}
		});
	}

	/**
	 * @function swapFromToLocation
	 * !!! Properly scoped
	 */
	swapFromToLocation(): void {
		let _self = this;
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		_self.$instance.find('.flight-trip--icon').on('click', function() {
			if($(this).attr('data-widgetName') === 'travelPass') {
				return;
			}
			let $fromLocationGetVal:any = curInstance.find('.ibe-from--location')[0].selectize.getValue();
			let $toLocationGetVal:any   = curInstance.find('.ibe-to--location')[0].selectize.getValue();

			$(this).toggleClass("rotate-180");

			curInstance.find('.ibe-from--location')[0].selectize.setValue($toLocationGetVal);
			curInstance.find('.ibe-to--location')[0].selectize.setValue($fromLocationGetVal);
			_self.isIbeSwapLocation=true;
		});
	}

	/**
	 * @function displayRecentSearch
	 * Function to display 3 recent search items
	 * !!! Properly scoped
	 */
  displayRecentSearch(): void { 
  	let _self = this;
  	let fromCity:string,
		  	toCity:string,
		  	fromDate:string,
		  	fromDateValue:string,
		  	toDate:string,
			toDateValue:string,
			totalPssgr:string,
			cabinClass:string,
			paymentmethod:string;
			

		let $recentContainer     = _self.$instance.find('.recent-container');
		let $recentSearchesLabel = _self.$instance.find("#recent-searches-label").val();
		$recentSearchesLabel = "Recent search";
  	let $recentContainerInnerHTML:any;
		let $recentContainerInnerHTMLStart = '<div class="col-lg-5 col-md-5 col-sm-12">'+ '<div class="recent-search--container"><div class="title">' + $recentSearchesLabel + ':</div>';
		let $recentContainerInnerHTMLEnd   = '</div></div>';
  	let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

  	if (recentSearchCookieArr.length > 0) {
  		let $recentContainerInnerHTMLMid = '';

  		for (var i = 3; i > 0; i--) {
			  let recentSearchCookieVal = recentSearchCookieArr[i];
			//  recentSearchCookieVal = recentSearchCookieVal.split("=")[1].replace(/"/g,"");
			 let recentItem = "recent-search-cookie-"+i;
			  recentSearchCookieVal = readValueFromCookie(recentItem).replace(/"/g,"");

			if(recentSearchCookieVal != '')
			{
  			let recentSearchCookieValArr = recentSearchCookieVal.split("-");

				fromCity      = recentSearchCookieValArr[0];
				toCity        = recentSearchCookieValArr[1];
				fromDate      = recentSearchCookieValArr[2];
				fromDateValue = recentSearchCookieValArr[3];
				totalPssgr 	  = recentSearchCookieValArr[4];
				cabinClass    = recentSearchCookieValArr[5];
  			if (recentSearchCookieValArr.length > 6) {
					toDate      = recentSearchCookieValArr[6];
					toDateValue = recentSearchCookieValArr[7];
  			}
			  paymentmethod=recentSearchCookieValArr[8];
  			$recentContainerInnerHTMLMid = $recentContainerInnerHTMLMid + '<div class="search-content"><div class="location"><div class="from-city--code">'+ fromCity +
  			'</div><div class="sep">-</div><div class="to-city--code">' + toCity +
  			'</div></div><div class="date"><div class="from-date" data-departDate="' + fromDateValue +
  			'">' + fromDate + '</div>';

				if (recentSearchCookieValArr.length > 6 && (toDate != undefined) && (toDateValue != undefined)) {
  				$recentContainerInnerHTMLMid = $recentContainerInnerHTMLMid + '<div class="sep">-</div><div class="to-date" data-returnDate="'+ toDateValue +
  				'">' + toDate + '</div>';
  			}

  			$recentContainerInnerHTMLMid = $recentContainerInnerHTMLMid + '</div>'+'<input type="hidden" class="total-psngr" value="' + totalPssgr + '"/><input type="hidden" class="paymentmethod" value="' + paymentmethod + '"/><input type="hidden" class="cabin-hidden" value="' + cabinClass + '"/>'+'</div>';
		
		  }
		}

  		$recentContainerInnerHTML = $recentContainerInnerHTMLStart + $recentContainerInnerHTMLMid + $recentContainerInnerHTMLEnd;
		//  $recentContainer.html($recentContainerInnerHTML);
		let $recentSearchDropdown  = '<div class="recent-container">'+$recentContainerInnerHTML+'</div>';
		  $('.evo-autocomplete--static').html($recentSearchDropdown);
		  $('.evo-autocomplete--static-mob').html($recentSearchDropdown);
  	}

  	/**
  	 * [getCookieByMatch description]
  	 * @param {string} regex [description]
  	 */
  	function getCookieByMatch(regex:RegExp) {
  		let cs:any = document.cookie.split(/;\s*/),
  				ret:Array<any> = [];
  		for (var i:number = 0; i < cs.length; i++) {
  			if (cs[i].match(regex)) {
  				ret.push(cs[i]);
  			}
  		}
  		return ret ;
	  }
	  /* Read cookie value by name */
	  function readValueFromCookie(name:string):any {
		var json="";
		var ca = document.cookie.split(';');
	
		name = name + "=";
	
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return decodeURIComponent(c.substring(name.length,c.length).replace(/\+/g, ' '));
			};
		}
		return json;
	}
  }

	/**
	 * @function recentSearch
	 * [recentSearch description]
	 * !!! Properly scoped
	 */
	recentSearch(): any {
		let _self = this;
		let $searchContainer = _self.$instance.find('.search-container');
		
		_self.$instance.find('.search-content').each(function(){
			let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
			let $searchItem = $(this);

			$searchItem.on('click', function(){
				let $fromCityCode: any     = $searchItem.find('.from-city--code').html();
				let $toCityCode: any       = $searchItem.find('.to-city--code').html();
				let $recentDepartDate: any = $searchItem.find('.from-date').attr('data-departDate');
				let $recentReturnDate: any = $searchItem.find('.to-date').attr('data-returndate');
				let $totalPassengersVal: any = $searchItem.find('.total-psngr').val();
				let $cabinClassVal: any	   = $searchItem.find('.cabin-hidden').val();
				let $cabinClass: any       = curInstance.find('.cabin-class');
				let $fromLocation: any     = curInstance.find('.ibe-from--location');
				let $toLocation: any       = curInstance.find('.ibe-to--location');
				let $bookdateSelector:any  = curInstance.find('.book-date--selector');
				let $depRetTitle: any      = curInstance.find('.dep-return--title');
				let $totalPassenger: any   = curInstance.find('.total-passengers');
				let $passengerSplit: any   = curInstance.find('.booking-category');
				
				_self.recentSearchActive = true;
				/* Recent search - Check one way*/
				let $deptDateExist:any = $searchItem.find('.date .to-date');
				let $getTripType:any = curInstance.find('.trip-type--container');
				let $passengerValArr:any;

				if (!$deptDateExist.length){
					$getTripType.find('.oneWayTrip').trigger('click');
				} else {
					$getTripType.find('.returnTrip').trigger('click');
				}

				$searchContainer.show();
				$('.evo-autocomplete--static').hide();

				// assign "to location" value to prepop into class variable
				// (to await completion of updating "from location")
				// following which the "to location" value will be populated
				_self.toPrepop = $toCityCode;
				
				_self.toCityFromCookie = $toCityCode;
				if($totalPassengersVal === "undefined"||undefined)
				{
					$totalPassengersVal = "1|0|0|0|0";
				}

				$passengerValArr = $totalPassengersVal.split("|");
				$totalPassenger.find('.total-nos').html($passengerValArr[0]);
				$passengerSplit.find('.ticket-adult--input').val($passengerValArr[1]);
				$passengerSplit.find('.ticket-child--input').val($passengerValArr[2]);
				$passengerSplit.find('.ticket-infant--input').val($passengerValArr[3]);
				$passengerSplit.find('.ticket-teenager--input').val($passengerValArr[4]);
				
				$cabinClass[0].selectize.setValue($cabinClassVal);
				$fromLocation[0].selectize.setValue($fromCityCode);
				$depRetTitle.find('.date-form--title').addClass('input-filled');
				
                let today:any ;
	            let dd:any;
                let yyyy:any;
	            today= new Date();
                dd = today.getDate();
                let mm = today.getMonth()+1; 
                yyyy = today.getFullYear();
                if(dd<10) 
                {
                  dd='0'+dd;
                } 

                if(mm<10) 
                {
                 mm='0'+mm;
                } 
                today = mm+'-'+dd+'-'+yyyy;
                var t=Date.parse(today);
                var recentDepartDate=Date.parse($recentDepartDate);
                var recentReturnDate=Date.parse($recentReturnDate);
                $bookdateSelector.find('.departureDate').val($recentDepartDate);
                $bookdateSelector.find('.returnDate').val($recentReturnDate);
				if (t>recentDepartDate) 
				{
				$bookdateSelector.find('.departureDate').val("");
			    }
			   if(t>recentReturnDate)
				{
                   $bookdateSelector.find('.returnDate').val("");
                }

				setTimeout(function() {
					if(!_self.isIbeSwapLocation){
						_self.recentSearchActive = false;
					}
					
				}, 1000);
			});
			
			$searchItem.find('a.close-recent--item').on('click', function(){
				$searchItem.remove();
			});
		});
	}

	/**
	 * @function calendarComponent
	 * Calendar component for single trip and multi city trip
	 * !!! Properly scoped
	 */
	calendarComponent(): void {
		let _self = this;

		let $ibeNowDate:any      = new Date();
		let $ibeTodayDate:any    = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate(), 0, 0, 0, 0);
		let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;
		let $ibeMaxLimitDate: any = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate() + maxDays, 0, 0, 0, 0);
		let $calStartDate:any    = new Date(_self.$instance.find('.departureDate').datepicker('getDate'));
		let $calEndDate:any      = new Date(_self.$instance.find('.returnDate').datepicker('getDate'));

		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;

		let $tripTypeContainer:any = _self.$instance.find('.trip-type--container');

		let $highlightDays:any = (date: any) => {
			var startDate:any = new Date(_self.$instance.find('.departureDate').datepicker('getDate'));
			var endDate:any   = new Date(_self.$instance.find('.returnDate').datepicker('getDate'));

			var modClasses:string = '';
			var modAltText:string = '';

			if ((startDate <= date) && (date <= endDate)) {
				modClasses += 'ui-state-selected';
				modAltText = 'Trip dates';
			}

			// highlight departure date
			if (Date.parse(startDate) == Date.parse(date)) {
				// console.log('start date match');
				modClasses += ' ' + 'ui-state-departureDate';
				modAltText = 'Departure date';
			}

			// highlight return date
			if (Date.parse(endDate) == Date.parse(date)) {
				// console.log('end date match');
				modClasses += ' ' + 'ui-state-returnDate';
				modAltText = 'Return date';
			}

			// console.log(modClasses);

			return [true, modClasses, modAltText];
		}
		var highlightForDateAvailablity = (date: any, type: any) => {
			if (_self.$instance.find('[data-widgetName="travelPass"]').length > 0) {
				const year = date.getFullYear();
				const month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are 0-indexed
				const day = ('0' + date.getDate()).slice(-2);
				const formattedDate = `${year}-${month}-${day}`;
				var highlightedDates = [];
				if (_self.$instance.find('[data-widgetName="travelPass"]') && type === 'dept'){
					highlightedDates = _self.availableDatesForTravelPassDept;
				} else {
					if (_self.$instance.find('[data-widgetName="travelPass"]') && type === 'return') {
						highlightedDates = _self.availableDatesForTravelPassReturn;
					}
				}
				if ($.inArray(formattedDate, highlightedDates) !== -1) {
					const [flag, className, title] = $highlightDays(date);
					const highlighted = 'highlighted ' + className;
					return [true, highlighted, "Available"];
				} else {
					let highlighteddays = $highlightDays(date);
					return [].concat(highlighteddays);
				}
			} else {
				return $highlightDays(date);
			}
		}
		var $ipad_not:any;
		if (navigator.userAgent.match(/iPad/i)) {				
			$ipad_not=1;
		} else {
			$ipad_not=2;
		}
		// Single trip calendar - return trip
		let $dateFormat:any = 'd M yy',
			$departDate = _self.$instance.find('.returnTrip .departureDate').datepicker({
				showButtonPanel: true,
				closeText: 		 '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: 		 $ibeTodayDate,
				beforeShowDay:	(date) => highlightForDateAvailablity(date, 'dept'),
				dateFormat: 	 'd M yy',
				maxDate: 		 $ibeMaxLimitDate,
				numberOfMonths:  $ipad_not,
				firstDay: 1,
				onClose: function(selectedDate: any) {
					$('.returnDate').datepicker("option", "minDate", ((selectedDate && selectedDate!='') ? selectedDate : $ibeNowDate));					
				},
				beforeShow: function(ele:any, obj:any) {

					_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
					if($('.ibe-refresh').length >0) {
						$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
					}
					$curDatepickerInst  = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
					if($('#ibe-standalone-iframe').length > 0) {  
						if (!$('#ui-datepicker-div').hasClass('iframe-calendar')) {
							$('#ui-datepicker-div').addClass('iframe-calendar');
						}
					}
					let $lowfareFrom:any = _self.$instance.find('.ibe-from--location').val();
					let $lowfareTo:any = _self.$instance.find('.ibe-to--location').val();
					let $lowfareDate:any = $('.departureDate').val();
					var dateObj = new Date($lowfareDate);
					var momentObj = moment(dateObj);
					var momentString = momentObj.format('DDMMYY');
					
					setTimeout(function () {
						_self.bcommon.lawfareAPI($lowfareFrom,$lowfareTo,momentString);
					}, 500);
				},
				afterShow: function() {
					_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				},
				onChangeMonthYear: function(month:any, year:any, dp:any) {
					_self.bcommon.lawfareAPI();
				}
			})
			.on('change', function() {
				$returnDate.datepicker('option', 'minDate', getDate(this));
				let $nextReturnDate:any = $(this).next('.returnDate');
				// console.log($nextReturnDate);

				// if return date == empty, focus on field
				if ($nextReturnDate.val() === "") {
					window.setTimeout($.proxy(function() {
						$nextReturnDate.focus();
					}, this), 100);
				} else {
					// do stuff
				}
			if(	_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
			_self.$instance.find('.ibe_freesidetrip').hide();					
			_self.$instance.find('.single-city--bookflight').show();
			}

			}),
			$returnDate = _self.$instance.find('.returnDate').datepicker({
				showButtonPanel: true,
				closeText: 		 '<i class="fa fa-times" aria-hidden="true"></i>',
				dateFormat: 	 'd M yy',
				minDate: 		 $ibeTodayDate,
				maxDate: 		 $ibeMaxLimitDate,
				numberOfMonths: $ipad_not,
				firstDay: 1,
				beforeShowDay: (date) => highlightForDateAvailablity(date, 'return'),
				onClose: function(selectedDate: any) {
				//	$('.returnTrip .departureDate').datepicker("option", "maxDate", selectedDate);
				},
				beforeShow: function(ele:any, obj:any) {
					_self.$instance.find('#ui-datepicker-div').removeClass('multicityTrip');
					if($('.ibe-refresh').length >0) {
						$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
					}
					_self.bcommon.appendDatepickerTitle('Please select your return date', obj.dpDiv);
					$curDatepickerInst  = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
					if($('#ibe-standalone-iframe').length > 0) { 
						if (!$('#ui-datepicker-div').hasClass('iframe-calendar')) {
							$('#ui-datepicker-div').addClass('iframe-calendar');
						}
					}
					let $lowfareFrom:any = _self.$instance.find('.ibe-from--location').val();
					let $lowfareTo:any = _self.$instance.find('.ibe-to--location').val();
					let $lowfareDate:any = $('.departureDate').val();
					var dateObj = new Date($lowfareDate);
					var momentObj = moment(dateObj);
					var momentString = momentObj.format('DDMMYY');
					setTimeout(function () {
						_self.bcommon.lawfareAPI($lowfareFrom,$lowfareTo,momentString);
						}, 500);
				},
				afterShow: function() {
					_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				},
				onChangeMonthYear: function(month:any, year:any, dp:any) {
					_self.bcommon.lawfareAPI();
				},
			})
				.on('change', function () {
					// $departDate.datepicker('option', 'maxDate', getDate(this));
					if (_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
						_self.$instance.find('.ibe_freesidetrip').hide();
						_self.$instance.find('.single-city--bookflight').show();
					}

				});


		/**
		 * Parse single date datepicker value from element
		 */
		let getDate:any = ($element: any) => {
			let $getDate: any;
			try {
				$getDate = $.datepicker.parseDate($dateFormat, $element.value);
			} catch(error) {
				//console.error(error);
				$getDate = null;
			}
			return $getDate;
		}

		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		// Hightlight Datepicker TD colours
		_self.$instance.find('#ui-datepicker-div').on('mouseover','td', () => {
			if (curInstance.find('.trip-type--container .returnTrip').hasClass('selected') &&
				curInstance.find('.departureDate').val()) {
				let _datepicker:any = $(this);
				_datepicker.parent().addClass('finalRow');

				$('.finalRow').prevAll().find('td:not(.ui-datepicker-unselectable)').addClass('highlight');
				_datepicker.prevAll('td:not(.ui-datepicker-unselectable)').addClass('highlight');

				if (_datepicker.parents().eq(3).hasClass('ui-datepicker-group-last')) {
					$('.ui-datepicker-group-first td:not(.ui-datepicker-unselectable)').addClass('highlight');
				}
			}
		});

		// Single trip calendar - one way trip
		_self.$instance.find('.oneWay-trip').datepicker({
			showButtonPanel: true,
			closeText      : '<i class="fa fa-times" aria-hidden="true"></i>',
			minDate        : $ibeTodayDate,
			dateFormat     : 'd M yy',
			maxDate        : $ibeMaxLimitDate,
			numberOfMonths : $ipad_not,
			firstDay: 1,
			beforeShowDay: (date) => highlightForDateAvailablity(date, 'dept'),
			beforeShow: function(ele:any, obj:any) {
				curInstance.find('#ui-datepicker-div').removeClass('multicityTrip');
				if($('.ibe-refresh').length >0) {
					$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
				}
				$curDatepickerInst = obj.dpDiv[0];
				$curDatepickerTitle = ele.dataset.datepickerTitle;
				if($('#ibe-standalone-iframe').length > 0) {  
					if (!$('#ui-datepicker-div').hasClass('iframe-calendar')) {
						$('#ui-datepicker-div').addClass('iframe-calendar');
					}
				}
				let $lowfareFrom:any = _self.$instance.find('.ibe-from--location').val();
				let $lowfareTo:any = _self.$instance.find('.ibe-to--location').val();
				let $lowfareDate:any = $('.departureDate').val();
				var dateObj = new Date($lowfareDate);
				var momentObj = moment(dateObj);
				var momentString = momentObj.format('DDMMYY');
				setTimeout(function () {
					_self.bcommon.lawfareAPI($lowfareFrom,$lowfareTo,momentString);
					}, 500);
			},
			afterShow: function() {
				_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
			
			},onChangeMonthYear: function(month:any, year:any, dp:any) {
				_self.bcommon.lawfareAPI();
			},
			})
			.on('change', function() {
				// $departDate.datepicker('option', 'maxDate', getDate(this));
			if(_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
			_self.$instance.find('.ibe_freesidetrip').hide();					
			_self.$instance.find('.single-city--bookflight').show();
			}

		});

		// Multi city trip calendar
		if (window.location.search.indexOf('multicity=true') > -1) {
			$tripTypeContainer.find('.returnTrip').removeClass('selected');
			$tripTypeContainer.find('.multiCityTrip').addClass('selected');
			_self.$instance.find('.single-cityTrip--Container').hide();
			_self.$instance.find('.multi-cityTrip--Container').show();
		}

		let $multiCityDateFormat:any = 'd M yy';

		let $multiCityDestGroup = _self.$instance.find('.multi-city--destination-group');

		// initialize datepicker for each multicity date item
		$multiCityDestGroup.each(function(index:number, el:any) {
			let $dateInput = $(this).find('.dateDeparture');
			let $nextdateInput:any;

			if (index < $multiCityDestGroup.length) {
				$nextdateInput = $($multiCityDestGroup[index+1]).find('.dateDeparture');
			}

			$dateInput.datepicker({
				showButtonPanel: true,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: $ibeNowDate,
				dateFormat: 'd M yy',
				maxDate: $ibeMaxLimitDate,
				numberOfMonths: $ipad_not,
				firstDay: 1,
				beforeShow: function(ele:any, obj:any) {
					if (!curInstance.find('.multicityTrip').length) {
						curInstance.find('#ui-datepicker-div').addClass("multicityTrip");
					}
					if($('.ibe-refresh').length >0) {
						$('#ui-datepicker-div').addClass('ibe-refresh-datepicker');
					}
					$curDatepickerInst = obj.dpDiv[0];
					$curDatepickerTitle = ele.dataset.datepickerTitle;
					if($('#ibe-standalone-iframe').length > 0) {  
						if (!$('#ui-datepicker-div').hasClass('iframe-calendar')) {
							$('#ui-datepicker-div').addClass('iframe-calendar');
						}
					}
				},
				afterShow: function() {
					_self.bcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
				}
			}).on('change', (e:any) => {
				if ($nextdateInput.length) {
					//$nextdateInput.datepicker('option', 'minDate', getMultiCityDate(e.target));
				}
			});
		});

		/**
		 * Parse multicity datepicker value from target element
		 */
		let getMultiCityDate:any = ($element: any) => {
			let $getMultiDate: any;
			try {
				// console.log($multiCityDateFormat, $element, $element.value);
				$getMultiDate = $.datepicker.parseDate($multiCityDateFormat, $element.value);
			} catch(error) {
				//console.error(error);
				$getMultiDate = null;
			}
			// console.log($getMultiDate);
			return $getMultiDate;
		}
	}

	/**
	 * @function passengerDetails
	 * Passenger details container
	 * !!! Properly scoped
	 */
	passengerDetails(): void {
		let _self = this;

		let $ticketAdultInput:number  = 1;
		let $ticketChildInput:number  = 0;
		let $ticketInfantInput:number = 0;
		let $totalTickets:number      = 1;
		let $ticketTeenagerInput: number = 0;
		let $totalPassenger:any 	  = _self.$instance.find('.total-passengers');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $groupBooking = curInstance.find('.group-booking');
		let $isEnableNinePass: any	=	$('#isEnableNinePass');
		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)'); // for mh sports only
 
		// $groupBooking.hide();

		// let $ticketYouthInput:number  = 0;

		$totalPassenger.find('.total-nos').html($totalTickets);

		_self.$instance.find('.ticket-nos-btn').on('click', function(e:any) {
			e.preventDefault();

			// get currently acted on input field
			var fieldName  = $(this).attr('data-field'),
					type       = $(this).attr('data-type'),
					input      = curInstance.find("input[name='"+fieldName+"']"),
					currentVal = parseInt(input.val());

			// apply calculation to acted-on field (plus/minus)
			if (!isNaN(currentVal)) {
					input.data('oldValue', currentVal);
					if (type == 'minus') {
							if (currentVal > parseInt(input.attr('min'))) {
									input.val(currentVal - 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == parseInt(input.attr('min'))) {
									$(this).attr('disabled', true);
							}

							if(fieldName== "passengersInfant"){
								if(currentVal-1>=$('#book-flight--container .passengersAdult').val())
								$('#book-flight--container .infant-nos .plus').attr('disabled', true);
							}
				
					} else if (type == 'plus') {
							if (currentVal < input.attr('max')) {
									input.val(currentVal + 1);
									input.trigger('change');
							}
							if (parseInt(input.val()) == input.attr('max')) {
									$(this).attr('disabled', true);
							}
							if(fieldName== "passengersInfant"){
								
								if(currentVal+1 >= $('#book-flight--container .passengersAdult').val()){
									$('#book-flight--container .infant-nos .plus').attr('disabled', true);
								}
							}
					}
			} else {
					input.val(0);
			}


			// updateTicketQtys();
		});

		// disable user input on field (next statement will no longer have any effect)
		_self.$instance.find('.minus-plus-input').attr('readonly', true);

		// store current value of input to data-attribute on focus
		// in case user manually edits fields
		_self.$instance.find('.minus-plus-input').on('focusin', function() {
			 $(this).data('oldValue', $(this).val());
		});
		// cabin class on change
		$('.cabin-class').on('change', function() {
			if($('.ibe_freesidetrip').is(":visible")) 
					{
					$('.ibe_freesidetrip').hide();					
					$('.single-city--bookflight').show();
					}		
		});
		// on value increment/decrement, update old value data-attribute
		_self.$instance.find('.minus-plus-input').on('change', function() {
			adultInfantValidation();

			let minValue     = parseInt($(this).attr('min'));
			let maxValue     = parseInt($(this).attr('max'));
			let valueCurrent = parseInt($(this).val());
			let name         = $(this).attr('name');
			if (valueCurrent >= minValue) {
				curInstance.find(".ticket-nos-btn[data-type='minus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}

			if (valueCurrent <= maxValue) {
				curInstance.find(".ticket-nos-btn[data-type='plus'][data-field='"+name+"']").removeAttr('disabled');
			} else {
				$(this).data('oldValue',$(this).val());
			}


			updateTicketQtys();
		});

		// prevent input to passenger number field by keyboard
		// only allow change from pressing buttons
		_self.$instance.find('.minus-plus-input').on('keydown', function (e:any) {
			if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
				(e.keyCode == 65 && e.ctrlKey === true) ||
				(e.keyCode >= 35 && e.keyCode <= 39)) {
				return;
			}
			if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
				e.preventDefault();
			}
		});

		// run once on ready
		// _self.$instance.find('.minus-plus-input').trigger('change');
		updateTicketQtys();

		/**
		 * calculate total ticket amount based on current values and populate display fields
		 * @return void
		 */
		function updateTicketQtys() {
			let $passengerDetailsActive = curInstance.find('[data-booking-passenger-details-selected]');
			// get current values in input field and assign to method vars
			$ticketAdultInput = parseInt($passengerDetailsActive.find('.ticket-adult--input').val());
			$ticketChildInput = parseInt($passengerDetailsActive.find('.ticket-child--input').val());
			$ticketInfantInput =parseInt($passengerDetailsActive.find('.ticket-infant--input').val());
			$ticketTeenagerInput = parseInt($passengerDetailsActive.find('.ticket-teenager--input').val());
			// only adult and child tickets count towards limit
			if (athleteId != null) {
				$totalTickets = $ticketAdultInput;
			} else {
				$totalTickets = $ticketAdultInput + $ticketTeenagerInput + $ticketChildInput;
			}
			let $totalPassengersVal: any = $totalTickets + $ticketInfantInput;
			let $totalPassenger: any = curInstance.find('.total-passengers');

			// update hidden input value for total tickets added
			// update display text for total tickets added
			_self.$instance.find('.total-tickets--value').val($totalTickets);
			$totalPassenger.find('.total-nos').html($totalPassengersVal);
			//10930 - PROD > MH.com > More than 9 passengers link is not appearing for other site edition
			// if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='') && ($totalTickets >= 9) && (window.location.href.indexOf('/my/') > 0))  {
			if (($isEnableNinePass.val()!='null') && ($isEnableNinePass.val()!='0') && ($isEnableNinePass.val()!='') && ($totalTickets >= 9))  {			
				$groupBooking.show();
			} else {
				$groupBooking.hide();
			}
			if ($totalTickets >= 2) {
				$totalPassenger.find('.type').html('Passengers');
			} else {
				$totalPassenger.find('.type').html('Passenger');
			}

			if ($totalTickets >= 9) {
				
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				 curInstance.find('.teenager-nos .input-group--btn .plus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			} else {
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', false);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', false);
			    curInstance.find('.teenager-nos .input-group--btn .plus').attr('disabled', false);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', false);
			}
			if (($('#members-travel--subsidy').length) > 0) {
				curInstance.find('.adult-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.teenager-nos .input-group--btn .plus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
				curInstance.find('.adult-nos .input-group--btn .minus').attr('disabled', true);
				curInstance.find('.child-nos .input-group--btn .minus').attr('disabled', true);
				curInstance.find('.teenager-nos .input-group--btn .minus').attr('disabled', true);
				// curInstance.find('.infant-nos .input-group--btn .minus').attr('disabled', true);
				// curInstance.find('.booking-person.infant-cat').addClass('hide');
				curInstance.find('.booking-person.group-booking').addClass('hide');
			}
		}

		/**
		 * test if infants added > adults added
			display error message if true
		 * @param {any} curInstance [current form instance]
		 */
		function adultInfantValidation() {
			let $passengerDetailsActive:any = curInstance.find('[data-booking-passenger-details-selected]');

			// declare passenger input variables
			// scope them to prevent multiple elements from being retrieved
			// (deals component uses the same class name for its inputs)
			let $adultInput  = $passengerDetailsActive.find('.ticket-adult--input');
			let $infantInput = $passengerDetailsActive.find('.ticket-infant--input');
			// let $childInput = $passengerDetailsActive.find('.ticket-child--input');
			// let $youthInput  = _self.$passengerDetailsActive.find('.ticket-youth--input');

			let $adultBookingErr  = curInstance.find('.adult-booking--error');
			let $infantBookingErr = curInstance.find('.infant-booking--error');
			// check if infants added exceeds adults added and display error if met
			let $adultInputVal:number  = parseInt($adultInput.val());
			let $infantInputVal:number = parseInt($infantInput.val());

			// only show error below infant item
			if($infantInputVal==$adultInputVal){
				$infantBookingErr.hide();
				curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
			}
			else if ($infantInputVal > $adultInputVal) {
				$infantBookingErr.show();
					curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', true);
				// $adultBookingErr.show();
			} else {
				$infantBookingErr.hide();
				curInstance.find('.infant-nos .input-group--btn .plus').attr('disabled', false);
				// $adultBookingErr.hide();
			}
		}

	}

	/**
	 * create validation list container for desktop booking form
	 */
	createDesktopErrorValidationList(): void {
		let _self = this;

		if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
			_self.$instance.find('.validation-content').append('<ul class="validation--error-list"></ul>');
		}
	}

	/**
	 * @function ibeSingleFormSubmitHandler
	 * !!! Properly scoped
	 */
	ibeSingleFormSubmitHandler(): void {
		let _self = this;

		let $errorValidation = _self.$instance.find('.error-validation').first();
		let $singleTripSubmitBtn:any    = _self.$instance.find('.single-city--bookflight');
		let $singleTripSubmitNoOffer_Btn:any    = _self.$instance.find('.desktop-search-nofst-form-submit');
		let $multiTripSubmitBtn:any     = _self.$instance.find('.multi-city--bookflight');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		//if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
			_self.getOfficeCode();

			$singleTripSubmitBtn.on('click', (evt:any) => {
				this.$error = [];
				evt.preventDefault();
				$errorValidation.show();
				let ieversion = new headerContent();
				ieversion.checkIEVersion_disablePupup();
				_self.bookingFormSubmit.singleBookingFormValidation(curInstance, _self.$officeCode, function ($officeCode: any) {
					// let isSideTripEnabled =  $('#isSideTripEnable').val();
					// if (isSideTripEnabled === 'Yes') {
					// 	if (_self.bookingFormSubmit.DesktopSidetripEligibilityCheck(curInstance)) {
					// 		$('.ibe_freesidetrip').show();
					// 		$('.single-city--bookflight').hide();
					// 	} else {
					// 		$('.ibe_freesidetrip').hide();
					// 		$('.single-city--bookflight').show();
					// 		let $fromOrigin = curInstance.find('.ibe-from--location').val();
					// 		_self.bookingFormSubmit.singleBookingFormSubmit(curInstance, '', '', '', $officeCode);
					// 	}
					// } else {
					// 		$('.ibe_freesidetrip').hide();
					// 		$('.single-city--bookflight').show();
					// 	let $fromOrigin = curInstance.find('.ibe-from--location').val();
					// 	_self.bookingFormSubmit.dxBookingFormSubmit(curInstance, '', '', '', $officeCode);
					// }

					curInstance.find('.ibe_freesidetrip').hide();
						curInstance.find('.single-city--bookflight').show();
						let $fromOrigin = curInstance.find('.ibe-from--location').val();
						_self.bookingFormSubmit.singleBookingFormSubmit(curInstance, '', '', '', $officeCode);
				

				});						
			
			});
			$singleTripSubmitNoOffer_Btn.on('click', (evt:any) => {
				this.$error = [];
				evt.preventDefault();
				$errorValidation.show();
				_self.bookingFormSubmit.singleBookingFormValidation(curInstance, _self.$officeCode, function($officeCode:any){
						_self.bookingFormSubmit.singleBookingFormSubmit(curInstance, '', '', '', $officeCode);
				});
			});
		//}
	}

	/**
	 * @function ibeMultiFormSubmitHandler
	 * !!! Properly scoped
	 */
	ibeMultiFormSubmitHandler(): void {
		let _self = this;

		let $errorValidation = _self.$instance.find('.error-validation').first();
		let $singleTripSubmitBtn:any    = _self.$instance.find('.single-city--bookflight');
		let $multiTripSubmitBtn:any     = _self.$instance.find('.multi-city--bookflight');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		//if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) )) {
			_self.getOfficeCode();

			$multiTripSubmitBtn.on('click', (e:any) => {
				this.$error = [];				
				e.preventDefault();
				let ieversion = new headerContent();
				ieversion.checkIEVersion_disablePupup();				
				$errorValidation.show();

				_self.bookingFormSubmit.multiBookingFormValidation(curInstance, _self.$officeCode, function($officeCode:any){
					let formObj:any = _self.multiBookingFormObject(curInstance);

					_self.bookingFormSubmit.multiBookingFormSubmit(curInstance, formObj, $officeCode);
				});
			});
		//}
	}

	/**
	 * @function multiBookingFormObject
	 * parse data object from multi booking form ond fields
	 * @return {any} - form object
	 * !!! Properly scoped
	 */
	multiBookingFormObject($instance:any): any {
		let _self = this;
		// clean data (remove unchecked but filled in flight details)
		// use data attributes for form validation instead (in case classes gets overwritten in the future)
		var destinationFields = $instance.find('[data-form-booking--trip] fieldset[data-type="destination-input"]');

		destinationFields.each(function(){
			// if flight details have been filled in but the flight row has been removed
			// (clicked the cross button), empty the input fields before serializing form
			// inputs.
			if (!parseInt(this.dataset.flightEnabled)) {
				var destFields = $(this).find('select');
				$(destFields).each(function(){
					this.selectedIndex = -1;
				});

				var depDateInput = $(this).find('input.dateDeparture');
				depDateInput[0].value = "";
			}
		});

		// parse form data
		let formData:any = $instance.find('[data-form-booking--trip]').serializeArray();
		let formObj:any = {};

		$(formData).each(function(i:any, field:any){
			formObj[field.name] = field.value;
		});

		// clean and re-order input vars for flight destinations
		formObj = _self.multiCleanDestData(formObj);

		// get office code from beginning destination value
		_self.getOfficeCode();

		return formObj;
	}

	/**
	 * @function getOfficeCode
	 * !!! Properly scoped
	 */
	getOfficeCode():void {
		let _self:any = this;

		let setOfficeID:any = ($fromOfficeID:string) => {
			_self.$officeCode = $fromOfficeID;
		}

		_self.$instance.find('.fromLocation').off('change.officecode').on('change.officecode', function(e:any) {
			let $pickerID = e.target.id;
			let $selected = $(this).find(":selected");
			// let $selected_value = $selected.val();
			let $selected_text = $selected.text();
			// let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
			let $fromOfficeID: any;
			if ($selected_text.includes('|')) {
				if ($selected_text.split('|')[0] === 'Recent') {
					$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
				} else {
					$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
				}
			} else {
				$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
			}
			setOfficeID($fromOfficeID);
		});

		_self.$instance.find('[name="multiCityfromLocation1"]').off('change.officecode').on('change.officecode', function(e:any) {
			let $pickerID = e.target.id;
			let $selected = $(this).find(":selected");
			// let $selected_value = $selected.val();
			let $selected_text = $selected.text();
			// let $fromOfficeID = $(this).parent().find('.selectize-dropdown-content .option.selected').parent().attr('data-group');
			let $fromOfficeID: any;
			if ($selected_text.includes('|')) {
				if ($selected_text.split('|')[0] === 'Recent') {
					$fromOfficeID = $selected_text.split('|')[9].replace(/\s+/g, "");
				} else {
					$fromOfficeID = $selected_text.split('|')[1].replace(/\s+/g, "");
				}
			} else {
				$fromOfficeID = $selected_text.substring($selected_text.lastIndexOf(",") + 1, $selected_text.indexOf("(")).replace(/\s+/g, "");
			}
			setOfficeID($fromOfficeID);
		});
	}

	/**
	 * expand this instance of ibe
	 * extrapolate method so that it can be used elsewhere
	 * instead of just selectize.focus()
	 * @author dominic <dominic.gan@mirumagency.com>
	 */
	expandIbe(instance:any):void {
		let $searchContainer = instance.find('.search-container');
		let $tripTypeContainer = instance.find('.trip-container');
		let $paymentTypeContainer = instance.find('.payment-type-container');
		let $recentContainer = instance.find('.recent-container');
		let $closeBtn = instance.find('.close-container');
		let $flightHotelBtn = instance.find('.flights-hotel-btn');
	
		$searchContainer.show();
		$searchContainer.parent().addClass('expanded');
		$tripTypeContainer.show();
		$paymentTypeContainer.show();
		$recentContainer.show();
		$flightHotelBtn.attr('style', 'display:inline-block;');
		$closeBtn.find('.close-booking').addClass('expanded');

	}	
		
	/**
	 * @function initSelectize
	 * ibe from location event handlers
	 * @param  {any} listItems [description]
	 * @return {any}           [description]
	 * !!! Properly scoped
	 */
	initSelectize(listItems:any, listToItems:any, listItemsMulticity: any):void {
		let _self = this;

		let $ibeFromLocation:any     = _self.$instance.find('.ibe-from--location');
		let $ibeFromBookingTitle:any = _self.$instance.find('.fromLocation .booking-form--title');
		let $ibeFromSelectize:any;

		let $ibeToLocation:any     = _self.$instance.find('.ibe-to--location');
		let $ibeToLocationById:any     = _self.$instance.find('#ibeToLocation');
		let $returnTripDateSelectorById:any     = _self.$instance.find('#returnTripDateSelector');
		let $oneWayTripDateSelectorById:any     = _self.$instance.find('#oneWayTripDateSelector');
		let $ibeToBookingTitle:any = _self.$instance.find('.toLocation .booking-form--title');
		let $ibeToSelectize:any;
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance
		let $recentHide:any =false;
		let $cugParam:any = $('#search-param-cug').val();
		let athleteId = document.cookie.match('(^|;)\\s*athleteId\\s*=\\s*([^;]+)');
		let $studentPortalDashboard:boolean =false;
		let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
		let studentDashboard = document.querySelector('.student-dashboard');
		if(studentEnrichIdCookieVal != null && studentDashboard != null){
			$studentPortalDashboard  = true;
		}
		let ukCities: any;
        let $isEnableCNN: any = $('#isEnableCNN');
        if (($isEnableCNN.val() != 'null') && ($isEnableCNN.val() != '0') && ($isEnableCNN.val() != '')) {
            ukCities = ($('[data-teenager-cities]').data('teenager-cities') != 'null' && $('[data-teenager-cities]').data('teenager-cities') != '' && $('[data-teenager-cities]').data('teenager-cities') != undefined) ? $('[data-teenager-cities]').data('teenager-cities').split(','): [];
        }
        else {
            ukCities = [];
        }
		// To check ibe widget is clicked
		let $ibeClickFlag:boolean =false;
		// let singleFromSelectizeReady:any = $.Deferred();
		// let singleToSelectizeReady:any = $.Deferred();
		let $cabinClass = $('.cabin-class');
		// showcaldender on locaiton selected 
		let showDatesCalender = () => {
			if(!$('#oneWayTripDateSelector').is(':visible')) {
				if ( $('#returnTripDateSelector').find('.departureDate').val()=='') {
					$returnTripDateSelectorById.find('input[name="start"]').focus();
				} else {
					if ( $('#oneWayTripDateSelector').find('.departureDate').val()=='') {
						$oneWayTripDateSelectorById.find('input[name="start"]').focus();
					}
				}
			}
		}
		let fetchDatesForTravel = (fromval, toVal, type) => {
			return new Promise((resolve, reject) => {
				try {
					_self.bcommon.fetchAvailability(fromval, toVal)
					.then((jsonData) => {
						if (Object.keys(jsonData).length !== 0) {
							if (type === 'departure') {
								_self.availableDatesForTravelPassDept = jsonData.data.results.map((result) => result.date);
							} else if (type === 'return') {
								_self.availableDatesForTravelPassReturn = jsonData.data.results.map((result) => result.date);
							}
						}
						resolve(); // Resolve the Promise once the data is processed
					})
					.catch((error) => {
						console.error('Error fetching availability:', error);
						if (type === 'departure') {
							_self.availableDatesForTravelPassDept = [];
						} else if (type === 'return') {
							_self.availableDatesForTravelPassReturn = [];
						}
						reject(error); // Reject the Promise if an error occurs
					});
				} catch(e) {
					console.log(e);
					if (type === 'departure') {
						_self.availableDatesForTravelPassDept = [];
					} else if (type === 'return') {
						_self.availableDatesForTravelPassReturn = [];
					}
					reject(e); // Reject the Promise if an error occurs
				}
			});
		};		

		$ibeFromLocation.html(listItems);
		  	/**
				 * [getCookieByMatch description]
				 * @param {string} regex [description]
				 */
				function getCookieByMatch(regex:RegExp) {
				let cs:any = document.cookie.split(/;\s*/),
						ret:Array<any> = [];
				for (var i:number = 0; i < cs.length; i++) {
					if (cs[i].match(regex)) {
						ret.push(cs[i]);
					}
				}
				return ret ;
			}

		$ibeFromLocation.selectize({
			onInitialize: function() {
				$('.isnt-uk').css('display', 'block');
				$('.passenger-details-selected .teenager-cat').css('display', 'none');
				$('.passenger-details-selected .is-uk').css('display', 'none');
				_self.wcag.selectizeInputAria($ibeFromLocation[0].selectize);
				$ibeFromSelectize = $($ibeFromLocation[0].selectize.$control[0]);
				let urlParams = _self.bcommon.getUrlVars(window.location.href);
			
				// singleFromSelectizeReady.resolve();
				// for mh sports hide child and infant in passenger dropdown #29941
				if (athleteId != null) {
					$('.passenger-details-selected .child-cat').css('display', 'none');
					$('.passenger-details-selected .infant-cat').css('display', 'none');
					curInstance.find('.couponCode').css('display', 'none');
				}

			},
			onFocus: function() {
				_self.expandIbe(curInstance);
				//call ibe preload function 

				//if($ibeClickFlag  == false){
				//	_self.ibePreload();
				//	$ibeClickFlag = true;
				//}

				$ibeFromBookingTitle.addClass('input-filled');
				$ibeFromBookingTitle.removeClass('has-error');
				$ibeFromSelectize.addClass('select-filled');
				$ibeFromSelectize.removeClass('has-error');
				let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
				let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);
				if($fromLocationChange !== '') {
					$ibeFromLocation[0].selectize.clear();
				}

				if (recentSearchCookieArr.length > 0 && $cugParam != "CUG" && $studentPortalDashboard == false && $('#members-travel--subsidy').length < 1 && $('#ibe-standalone-iframe').length < 1) {
					if ($fromLocationChange == '') {
						// $('.evo-autocomplete--static').show();
						// $(".fromLocation .selectize-dropdown .selectize-dropdown-content").hide();
					} else {
						$('.evo-autocomplete--static').hide();
						$(".fromLocation .selectize-dropdown .selectize-dropdown-content").show();
					}
				}

				if(standAloneIBE)
				{
					$('.evo-autocomplete--static').hide();
					$(".fromLocation .selectize-dropdown .selectize-dropdown-content").show();
				}
				if(standAloneIBEFrame)
				{
					$('.evo-autocomplete--static').hide();
					$(".fromLocation .selectize-dropdown .selectize-dropdown-content").show();
					$('#ibe-standalone-iframe').attr('data-isopen', 'true');
				}
				// if (($('#ibe-standalone-travelpass').length) > 0) {
				// 	$("html, body").animate({ scrollTop: $(document).height()},1000);
				// }

			},

			onChange: function(value:any) {
				//#region enrich always on
					// check user logged in && enrich always on 
					let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
					let cashFlowType = _self.$instance.find('input[name="cash_miles_type"]:checked').val();
					let $tripType = $('.trip-sidetrip-container .trip-type--container li.selected a').attr('data-triptype');
					if(_self.enrichAlwaysON=='true' && !_self.isMHExplorer() && loginTokenCookieVal && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
						_self.ONDenrichFromLocation($ibeFromLocation[0].selectize.options[value]);	
					}
					else{
						_self.isEligibleEnrichAlwaysOn=false;
					}
				//#endregion
				let search:any=true;
				$ibeFromBookingTitle.addClass('input-filled');
				$ibeFromSelectize.addClass('select-filled');
				/* Handling passenger type for uk cities */
				if (ukCities.includes(value.split('_')[0]) || ukCities.includes($ibeToLocation.val().split('_')[0])) {
					$('.passenger-details-selected .teenager-cat').css('display', 'block');
					$('.passenger-details-selected .is-uk').css('display', 'block');
					$('.isnt-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = true;
				} else {
					$('.isnt-uk').css('display', 'block');
					$('.passenger-details-selected .teenager-cat').css('display', 'none');
					$('.passenger-details-selected .is-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = false;
					_self.$instance.find('.passenger-details-selected .ticket-teenager--input').val(0).trigger('change');
				}
				if ($ibeFromLocation.text().trim().split('|')[0] === 'Recent') {
					$('body').append('<span id="search_recentpayment" style="display:none">new-dynamic-text</span>');
					let $fromLocation: any = curInstance.find('.ibe-from--location');
					let $getTripType: any = curInstance.find('.trip-type--container');
					let $cabinClass: any = curInstance.find('.cabin-class');
					let $toLocation: any = curInstance.find('.ibe-to--location');
					let $bookdateSelector: any = curInstance.find('.book-date--selector');
					let $depRetTitle: any = curInstance.find('.dep-return--title');
					let $totalPassenger: any = curInstance.find('.total-passengers');
					let $passengerSplit: any = curInstance.find('.booking-category');
					let $passengerValArr: any;

					if ($ibeFromLocation.text().trim().split('|')[7] === "undefined" || undefined) {
						$getTripType.find('.oneWayTrip').trigger('click');
					} else {
						$getTripType.find('.returnTrip').trigger('click');
					}

					_self.toPrepop = $ibeFromLocation.text().trim().split('|')[3];

					_self.toCityFromCookie = $ibeFromLocation.text().trim().split('|')[3];
					

					if($ibeFromLocation.text().trim().split('|')[17]=='MC')
					{
						$('input[value="cash_miles"]').prop("checked", true).trigger("click");
					}
					else if($ibeFromLocation.text().trim().split('|')[17]=='M')
					{
						if ($('.enrich-revamp').length > 0) {
							$('.enrich-revamp .redeem-flight').trigger("click");
						}
						$('input[value="miles"]').prop("checked", true).trigger("click");
					}
					else if($ibeFromLocation.text().trim().split('|')[17]=='C')
					{
						if ($('.enrich-revamp').length > 0) {
							$('.enrich-revamp .book-flight').trigger("click");
						}
						$('input[value="cash"]').prop("checked", true).trigger("click");
					}
					$totalPassenger.find('.total-nos').html($ibeFromLocation.text().trim().split('|')[12] ? $ibeFromLocation.text().trim().split('|')[12] : "1");
					$passengerSplit.find('.ticket-adult--input').val($ibeFromLocation.text().trim().split('|')[13] ? $ibeFromLocation.text().trim().split('|')[13] : "0");
					$passengerSplit.find('.ticket-child--input').val($ibeFromLocation.text().trim().split('|')[14] ? $ibeFromLocation.text().trim().split('|')[14] : "0");
					$passengerSplit.find('.ticket-infant--input').val($ibeFromLocation.text().trim().split('|')[15] ? $ibeFromLocation.text().trim().split('|')[15] : "0");
					$passengerSplit.find('.ticket-teenager--input').val($ibeFromLocation.text().trim().split('|')[16] ? $ibeFromLocation.text().trim().split('|')[16] : "0");
					let $cabinClassval = $ibeFromLocation.text().trim().split('|')[11];

					if($cabinClassval=="CFFFMC" || $cabinClassval=="CFFFMILES"){
						$cabinClassval= "CFFFIRST"
					} 
					else if($cabinClassval=="CFFJMC" || $cabinClassval=="CFFJMILES" || $cabinClassval=="CFFSTUBUS"){
						$cabinClassval= "CFFBUS"
					} 
					else if($cabinClassval =="CFFYMC" || $cabinClassval =="CFFYMILES" || $cabinClassval=="CFFSTUECO"){
						$cabinClassval= "CFFECO"
					}
					$cabinClass[0].selectize.setValue($cabinClassval);					
					$depRetTitle.find('.date-form--title').addClass('input-filled');

					let today: any;
					let dd: any;
					let yyyy: any;
					today = new Date();
					dd = today.getDate();
					let mm = today.getMonth() + 1;
					yyyy = today.getFullYear();
					if (dd < 10) {
						dd = '0' + dd;
					}

					if (mm < 10) {
						mm = '0' + mm;
					}
					today = mm + '-' + dd + '-' + yyyy;
					var t = Date.parse(today);
					var recentDepartDate = Date.parse($ibeFromLocation.text().trim().split('|')[6]);
					if ($ibeFromLocation.text().trim().split('|')[8] !== "undefined" || undefined) {
						var recentReturnDate = Date.parse($ibeFromLocation.text().trim().split('|')[8]);
						$bookdateSelector.find('.returnDate').val($ibeFromLocation.text().trim().split('|')[8]);
					}
					$bookdateSelector.find('.departureDate').val($ibeFromLocation.text().trim().split('|')[6]);

					if (t > recentDepartDate) {
						$bookdateSelector.find('.departureDate').val("");
					}
					if ($ibeFromLocation.text().trim().split('|')[8] !== "undefined" || undefined) {
						if (t > recentReturnDate) {
							$bookdateSelector.find('.returnDate').val("");
						}
					}									
				} 
				if ($ibeFromLocation.val().split('_')[0] === $ibeFromLocation.text().trim().split('|')[3]) {
					$ibeToSelectize.addClass('has-error');
					$ibeToBookingTitle.addClass('has-error');
				}
				else {
					let ibeFromLocationVal = $ibeFromLocation.val().trim().split('_')[0];
					let cashFlowType = _self.$instance.find('input[name="cash_miles_type"]:checked').val();

					// let ibeToLocationPrepop = $ibeToLocation.attr('data-prepop-value');

					if (_self.toCityFromCookie) {
						_self.toCityFromCookie = undefined;
					}
					// } else {
						// update ond list if no prepop value defined
						// if (!ibeToLocationPrepop) {
					if (value.length) { // only get new toLocation values if fromLocation val is filled (do nothing if empty value)
						if ($('#ibe-standalone-travelpass').length < 1) {
							if (cashFlowType == "miles" || cashFlowType == "cash_miles") {
								_self.bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationVal, $ibeToLocation);
							} else {
								let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
								let studentDashboard = document.querySelector('.student-dashboard');
								if (studentEnrichIdCookieVal != null && studentDashboard != null) {
									_self.bcommon.updateAirportOnDListOnFlowChangeNew("Redemption", ibeFromLocationVal, $ibeToLocation);
								} else {
									_self.bcommon.updateAirportOnDListOnFlowChangeNew("Revenue", ibeFromLocationVal, $ibeToLocation);
								}
							}
						} else {
							let $travelPassZone: any = $('#travel_pass').find('#travel-pass--id');
							var $data: any = {
								zone: $travelPassZone.val().split('|')[3]
							};
							let airportlist = _self.bcommon.getTravelPassAirPorts($data);
							let $updateTypes: Array<any> = [];
							$updateTypes.push($ibeToLocation);
							_self.bcommon.updateTravelPassAirportList(ibeFromLocationVal, $updateTypes, airportlist);	
						}
					}
						// }
					$ibeToSelectize.removeClass('has-error');
					$ibeToBookingTitle.removeClass('has-error');
					if (ibeFromLocationVal != "" && !_self.recentSearchActive ) {
						setTimeout(function() {
							if ($ibeFromLocation.text().trim().split('|')[0] !== 'Recent' && !_self.isIbeSwapLocation) {
								$ibeToLocationById.find('input[type="select-one"]').focus();
							}
							$ibeToBookingTitle.addClass('input-filled');
							$ibeToSelectize.addClass('select-filled');
						}, 300);
					}
					_self.isIbeSwapLocation=false;
				}
		if(_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
				_self.$instance.find('.ibe_freesidetrip').hide();					
				_self.$instance.find('.single-city--bookflight').show();
			}
			$('#search_recentpayment').remove();
			//
		
			},
			onBlur: function(data:any) {
				let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
				if($recentHide == false){
				//$('.evo-autocomplete--static').hide(); 
				}
				if ($fromLocationChange == '') {
					$ibeFromBookingTitle.removeClass('input-filled');
					$ibeFromSelectize.removeClass('select-filled');
				} else {
					$ibeFromBookingTitle.addClass('input-filled');
					$ibeFromSelectize.addClass('select-filled');
				}
				$recentHide = false;
			},
			
			onLoad: function(data:any) {
				$ibeFromLocation[0].selectize.trigger('blur');
			},	
			lockOptgroupOrder: true,
			searchField      : ['text'],
			selectOnTab      : true,
			render: {
				item: function(item:any, escape:any) {	
					if (item.text.split('|')[0] === 'Recent') {
						return '<div>' +
							(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[2].split('__')[0]) + ' (' + escape(item.text.split('|')[1]) + ')</span>' : '') +
							'</div>';
					} else {
						return '<div>' +
							(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) +  ')</span>' : '') +
							'</div>';
					}	
			
				},
				option: function(item:any, escape:any) {
					if ($('#ibe-standalone-travelpass').length < 1) {
						if (item.text.split('|')[0] === 'Recent') {
							let recentRetdate: string = (item.text.split('|')[8] !== "undefined" || undefined) ? ' - ' + escape(item.text.split('|')[8]) : '';
							let numberPax: string = (item.text.split('|')[12] !== "undefined" || undefined) ? ', ' + escape(item.text.split('|')[12]) + ' ' + '<i class="fa fa-user" aria-hidden="true"></i>' : '';
							return '<div>' +
								(item.text ? '<p><span class = "airportname">' + escape(item.text.split('|')[2].split('__')[0]) +
									'</span> to <span class = "airportname">' + escape(item.text.split('|')[4].split('__')[0]) +
									'</span></p><p><span class = "recentdate">' +
									escape(item.text.split('|')[6]) + recentRetdate + numberPax + '</span></p>' : '') +
								'</div>';
						} else {
							return '<div>' +
								(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' +
									escape(item.text.split('|')[1]) + '<span class = "airportcode">' +
									escape(item.text.split('|')[2]) + '</span>' : '') +
								'</div>';
						}
					} else {
						if (item.text.split('|')[0] === 'Recent') {
							let recentRetdate: string = (item.text.split('|')[8] !== "undefined" || undefined) ? ' - ' + escape(item.text.split('|')[8]) : '';
							let numberPax: string = (item.text.split('|')[12] !== "undefined" || undefined) ? ', ' + escape(item.text.split('|')[12]) + ' ' + '<i class="fa fa-user" aria-hidden="true"></i>' : '';
							return '<div>' +
								(item.text ? '<p><span class = "airportname">' + escape(item.text.split('|')[2].split('__')[0]) +
									'</span> to <span class = "airportname">' + escape(item.text.split('|')[4].split('__')[0]) +
									'</span></p><p><span class = "recentdate">' +
									escape(item.text.split('|')[6]) + recentRetdate + numberPax + '</span></p>' : '') +
								'</div>';
						} else {
							return '<div>' +
								(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' +
									'<span class = "airportcode">' +
									escape(item.text.split('|')[2]) + '</span></p><p>' + escape(item.text.split('|')[1]) + '</p>' : '') +
								'</div>';
						}
					}
				}
			}
		});
		
		$(".ibe-from--location").keydown(function(event: any) {
			if (event.keyCode === 9) {
				event.preventDefault();
				event.stopPropagation();
			}
		});

		$('.evo-autocomplete--static').mousedown(function(e:any) {
			$recentHide = true;
			if ($('#members-travel--subsidy').length < 1) {
				//$('.evo-autocomplete--static').show();
			}
		   });
		
		$(".ibe-from--location .selectize-input input").keyup(function(){ 
			//let $fromLocationChange = $ibeFromLocation.find('option:selected').text();
			let recentSearchCookieArr = getCookieByMatch(/^recent-search-cookie-\d+=/);

			if (recentSearchCookieArr.length > 0 && $cugParam != "CUG" && $studentPortalDashboard == false && $('#members-travel--subsidy').length < 1 && $('#ibe-standalone-iframe').length < 1) {
				if ($(".ibe-from--location .selectize-input input").val() == '') {
					// $('.evo-autocomplete--static').show();
					// $(".fromLocation .selectize-dropdown .selectize-dropdown-content").hide();
				} else {
					$('.evo-autocomplete--static').hide();
					$(".fromLocation .selectize-dropdown .selectize-dropdown-content").show();
				}
			}
		});
		
		// singleFromSelectizeReady.promise();

		$ibeToLocation.html(listToItems);
		$ibeToLocation.selectize({
			onInitialize: function() {
				_self.wcag.selectizeInputAria($ibeToLocation[0].selectize);
				$ibeToSelectize = $($ibeToLocation[0].selectize.$control[0]);

				// singleToSelectizeReady.resolve();
			},
			onFocus: function() {
				_self.expandIbe(curInstance);

				$ibeToBookingTitle.addClass('input-filled');
				$ibeToBookingTitle.removeClass('has-error');
				$ibeToSelectize.addClass('select-filled');
				$ibeToSelectize.removeClass('has-error');
				let $toLocationChange = $ibeToLocation.find('option:selected').text();
				if (!_self.isIbePrepop && !_self.isIbeSwapLocation) {
					if ($toLocationChange !== '') {
						$ibeToLocation[0].selectize.clear();
					}
				}			
				if($('#ibe-standalone-iframe').length > 0) {
					$('#ibe-standalone-iframe').attr('data-isopen', 'true');      
				}
			},
			onChange: function(value: any) {
				//#region enrich always on
					// check user logged in && enrich always on 
					let loginTokenCookieVal = document.cookie.match('(^|;)\\s*sapphire\\s*=\\s*([^;]+)');
					let cashFlowType = _self.$instance.find('input[name="cash_miles_type"]:checked').val();
					let $tripType = $('.trip-sidetrip-container .trip-type--container li.selected a').attr('data-triptype');
					if(_self.enrichAlwaysON=='true' && !_self.isMHExplorer() && loginTokenCookieVal && cashFlowType=='cash' && ($tripType=='R' || $tripType=='O')){
						_self.ONDenrichToLocation($ibeToLocation[0].selectize.options[value]);	
					}	
					else{				
						_self.isEligibleEnrichAlwaysOn=false;					
					}
						
				//#endregion					
				$ibeToBookingTitle.addClass('input-filled');
				$ibeToSelectize.addClass('select-filled');
				if (ukCities.includes(value.split('_')[0]) || ukCities.includes($ibeFromLocation.val().split('_')[0])) {
					$('.passenger-details-selected .teenager-cat').css('display', 'block');
					$('.passenger-details-selected .is-uk').css('display', 'block');
					$('.isnt-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = true;
				} else {
					$('.isnt-uk').css('display', 'block');
					$('.passenger-details-selected .teenager-cat').css('display', 'none');
					$('.passenger-details-selected .is-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = false;
					_self.$instance.find('.passenger-details-selected .ticket-teenager--input').val(0).trigger('change');
				}
				if ($ibeFromLocation.val().trim().split('_')[0] === $ibeToLocation.val() && $ibeFromLocation.val().length > 0) {
					$ibeToSelectize.addClass('has-error');
					$ibeToBookingTitle.addClass('has-error');
				}
				else {
					$ibeToSelectize.removeClass('has-error');
					$ibeToBookingTitle.removeClass('has-error');
				}
				let fromval:any =$ibeFromLocation.val().trim().split('_')[0];
				let toVal:any = $ibeToLocation.val().trim().split('|')[0];

				if( fromval!='' && $ibeToLocation.val()!='' ){
					_self.bcommon.lawfareAPI(fromval,$ibeToLocation.val());
				}
				if ($ibeToLocation.val().trim() != "" && !_self.recentSearchActive ) {
					if(_self.$instance.find('[data-widgetName="travelPass"]').length > 0) {
						function callback() {
							fetchDatesForTravel(toVal, fromval, 'return')
								.then(() => {
									showDatesCalender();
									_self.isIbePrepop = false;
								})
								.catch((error) => {
									console.error("Error fetching 'return' dates:", error);
									showDatesCalender();
									_self.isIbePrepop = false;
								});
						}
						function fetchDeptAndReturndatesAvailablity() {
							fetchDatesForTravel(fromval, toVal, 'departure')
								.then(() => {
									callback();
								})
								.catch((error) => {
									console.error("Error fetching 'departure' dates:", error);
									callback();
							});
						}
						fetchDeptAndReturndatesAvailablity();
					} else {
						setTimeout(function() {
							_self.availableDatesForTravelPassDept = [];
							_self.availableDatesForTravelPassReturn = [];
							showDatesCalender();
							_self.isIbePrepop = false;
						}, 200);
					}
				}	
		if(_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
				_self.$instance.find('.ibe_freesidetrip').hide();					
				_self.$instance.find('.single-city--bookflight').show();
			}	

			},
			onBlur: function() {
				let $toLocationChange = $ibeToLocation.find('option:selected').text();
	
				if ($toLocationChange == '') {
					$ibeToBookingTitle.removeClass('input-filled');
					$ibeToSelectize.removeClass('select-filled');
				} else {
					$ibeToBookingTitle.addClass('input-filled');
					$ibeToSelectize.addClass('select-filled');
				}
			},
			onLoad: function(data:any) {
				_self.fillToPrepopValue($ibeToLocation[0].selectize);
				$ibeToLocation[0].selectize.trigger('blur');
			},
			lockOptgroupOrder: true,
			searchField      : ['text'],
			selectOnTab      : true,
			render: {
				item: function(item:any, escape:any) {
					return '<div>' +
					(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>': '') +
					'</div>';	
			
				},
				option: function (item: any, escape: any) {	
					if ($('#ibe-standalone-travelpass').length < 1) {
						return '<div>' +
							(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' + escape(item.text.split('|')[1]) + '<span class = "airportcode">' + escape(item.text.split('|')[2]) + '</span>' : '') +
							'</div>';
					}
					else {
						return '<div>' +
							(item.text ? '<p class = "airportline"><span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + '</span>' + '<span class = "airportcode">' + escape(item.text.split('|')[2]) + '</span></p><p>' + escape(item.text.split('|')[1]) + '</p>' : '') +
							'</div>';
					}
				}
			}
		});
		let isSideTripEnabled =  $('#isSideTripEnable').val();
		if (isSideTripEnabled === 'Yes') {
			$("#book-flight--container .desktop-flight-widget:not([class*='passenger-details']) :input").change(function(evt:any) { 
				//if(evt.target.classList.contains("minus-plus-input") === false){
				_self.DesktopSiteTripButtonDisplay('');
				//}
			});	
	}

		let $multiCityDestGroup 	= _self.$instance.find('.multi-city--destination-group');
		let multiCityGrpArray:any   =	[];
		$multiCityDestGroup.each(function(i:number){
			// MultiCity From Location event handlers
			let $mcityFromLocation:any     = $(this).find('.multicity-from--location'),
				$mcityFromBookingTitle:any = $(this).find('.mc-from--location .booking-form--title'),
				$mcityFromSelectize:any,
				$mcityFromSelectInput:any  = $(this).find('select.mc-from--location'),
				$bookdateSelector:any      = $(this).find('.book-date--selector');
				let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instanc			

			$mcityFromLocation.html(listItemsMulticity);
			$mcityFromLocation.selectize({
				onInitialize: function() {
					_self.wcag.selectizeInputAria($mcityFromLocation[0].selectize);
					$mcityFromSelectize = $($mcityFromLocation[0].selectize.$control[0]);
				},
				onFocus: function() {
				_self.expandIbe(curInstance);
// $searchContainer.show();
// $searchContainer.parent().addClass('expanded');
					$mcityFromBookingTitle.addClass('input-filled');
					$mcityFromSelectize.addClass('select-filled');
					$bookdateSelector.removeClass('datepicker-selected');
					$mcityFromSelectize.removeClass('has-error');
					$mcityFromBookingTitle.removeClass('has-error');
					let $mcityfromLocationChange = $mcityFromLocation.find('option:selected').text();				
					if($mcityfromLocationChange !== '') {
						$mcityFromLocation[0].selectize.clear();
					}
					if($('#ibe-standalone-iframe').length > 0) {
						$('#ibe-standalone-iframe').attr('data-isopen', 'true');      
					}  
				},
				onChange: function(value:any) {
					let mcityFromLocationValue:any = $mcityFromLocation.val().trim().split('_')[0];
					let mcityToLocationValue:any = $mcityToLocation.val().trim().split('_')[0];
					let j:any = 1;
					while (j < 7) {
						let frmVal:any = $('[name="multiCityfromLocation'+j+'"]').val();
						multiCityGrpArray.push(frmVal);
						 let toVal:any = $('[name="multiCitytoLocation'+j+'"]').val();
						 multiCityGrpArray.push(toVal);
						j++;
					}
					
				/* Handling passenger type for uk cities */
				if(ukCities.some((v:any)=> multiCityGrpArray.indexOf(v) !== -1)){
					$('.passenger-details-selected .teenager-cat').css('display', 'block');
					$('.passenger-details-selected .is-uk').css('display', 'block');
					$('.isnt-uk').css('display', 'none');
					_self.isUkCitySelectedForIbeSearch = true;
					} else {
						$('.isnt-uk').css('display', 'block');
						$('.passenger-details-selected .teenager-cat').css('display', 'none');
						$('.passenger-details-selected .is-uk').css('display', 'none');
						_self.isUkCitySelectedForIbeSearch = false;
						_self.$instance.find('.passenger-details-selected .ticket-teenager--input').val(0).trigger('change');
					}
					multiCityGrpArray.length = 0;
					let toLocationEl:any = $($multiCityDestGroup[i]).find('select.multicity-to--location');
					if (value.length) {
						 // only get new toLocation values if fromLocation val is filled (do nothing if empty value)
						// _self.bcommon.updateAirportOnDListOnFlowChangeNew("Revenue", mcityFromLocationValue, toLocationEl);
						_self.bcommon.updateAirportOnDListOnFlowChangeMulticity("multicity", mcityFromLocationValue, toLocationEl, $mcityFromLocation);
					}
					$mcityFromBookingTitle.addClass('input-filled');
					$mcityFromSelectize.addClass('select-filled');
							if(_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
				_self.$instance.find('.ibe_freesidetrip').hide();					
				_self.$instance.find('.multi-city--bookflight').show();
			}
				},
				onBlur: function() {
					let $multiFromLocationVal = $mcityFromLocation.parent().find("option:selected").text();
					if ($multiFromLocationVal == '') {
						$mcityFromBookingTitle.removeClass('input-filled');
						$mcityFromSelectize.removeClass('select-filled');
					} else {
						$mcityFromBookingTitle.addClass('input-filled');
						$mcityFromSelectize.addClass('select-filled');
					}
				},
				onLoad: function(data:any) {
					$mcityFromLocation[0].selectize.trigger('blur');
				},
				lockOptgroupOrder: true,
				searchField: ['text'],
				selectOnTab: true,
				render: {
					item: function(item:any, escape:any) {					
						return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>': '') +
						'</div>';				
					},
					option: function(item:any, escape:any) {
						return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' + escape(item.text.split('|')[1]) +'<span class = "airportcode">'+ escape(item.text.split('|')[2])+'</span>': '') +
						'</div>';
					}
				}
			});

			/** MultiCity To Location event handlers*/
			let $mcityToLocation:any     = $(this).find('.multicity-to--location'),
				$mcityToBookingTitle:any = $(this).find('.mc-to--location .booking-form--title'),
				$mcityToSelectize:any,
				$mcityToSelectInput:any  = $(this).find('select.mc-to--location');

			$mcityToLocation.html(listItemsMulticity);
			$mcityToLocation.selectize({
				onInitialize: function() {
					_self.wcag.selectizeInputAria($mcityToLocation[0].selectize);
					$mcityToSelectize = $($mcityToLocation[0].selectize.$control[0]);
				},
				onFocus: function() {
					$mcityToBookingTitle.addClass('input-filled');
					$mcityToSelectize.addClass('select-filled');
					$bookdateSelector.removeClass('datepicker-selected');
					$mcityToSelectize.removeClass('has-error');
					$mcityToBookingTitle.removeClass('has-error');
					let $mcitytoLocationChange = $mcityToLocation.find('option:selected').text();	
					if (!_self.isIbePrepop) {
						if($mcitytoLocationChange !== '') {
							$mcityToLocation[0].selectize.clear();
						}
					}
					_self.isIbePrepop = false;	
					if($('#ibe-standalone-iframe').length > 0) {
						$('#ibe-standalone-iframe').attr('data-isopen', 'true');      
					}  
				},
				onChange: function(value: any) {
					let mcityToLocationValue:any = $mcityToLocation.val().trim().split('_')[0];
					let j:any = 1;
					multiCityGrpArray = [];
					while (j < 7) {
						let toVal:any = $('[name="multiCitytoLocation'+j+'"]').val();
						let frVal:any = $('[name="multiCityfromLocation'+j+'"]').val();
						multiCityGrpArray.push(toVal);
						multiCityGrpArray.push(frVal);
						j++;
					}
					if(ukCities.some(v=> multiCityGrpArray.indexOf(v) !== -1)){
						$('.passenger-details-selected .teenager-cat').css('display', 'block');
						$('.passenger-details-selected .is-uk').css('display', 'block');
						$('.isnt-uk').css('display', 'none');
						_self.isUkCitySelectedForIbeSearch = true;
						} 
					else {
						$('.isnt-uk').css('display', 'block');
						$('.passenger-details-selected .teenager-cat').css('display', 'none');
						$('.passenger-details-selected .is-uk').css('display', 'none');
						_self.isUkCitySelectedForIbeSearch = false;
						_self.$instance.find('.passenger-details-selected .ticket-teenager--input').val(0).trigger('change');
					}
					$mcityToBookingTitle.addClass('input-filled');
					$mcityToSelectize.addClass('select-filled');
					if ($mcityFromLocation.val().trim().split('_')[0] === $mcityToLocation.val()) {
						$mcityToSelectize.addClass('has-error');
						$mcityToBookingTitle.addClass('has-error');
					}
					else {
						$mcityToSelectize.removeClass('has-error');
						$mcityToBookingTitle.removeClass('has-error');
					}
					if(_self.$instance.find('.ibe_freesidetrip').is(":visible")) {
				_self.$instance.find('.ibe_freesidetrip').hide();					
				_self.$instance.find('.multi-city--bookflight').show();
			}
				},
				onBlur: function() {
					let $multiToLocationVal = $mcityToLocation.parent().find("option:selected").text();
					if ($multiToLocationVal == '') {
						$mcityToBookingTitle.removeClass('input-filled');
						$mcityToSelectize.removeClass('select-filled');
					} else {
						$mcityToBookingTitle.addClass('input-filled');
						$mcityToSelectize.addClass('select-filled');
					}
				},
				onLoad: function(data:any) {
					_self.fillToPrepopValue($mcityToLocation[0].selectize);
					$mcityToLocation[0].selectize.trigger('blur');
				},
				lockOptgroupOrder: true,
				searchField: ['text'],
				selectOnTab: true,
				render: {
					item: function(item:any, escape:any) {					
						return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ' (' + escape(item.text.split('|')[2]) + ')</span>': '') +
						'</div>';				
					},
					option: function(item:any, escape:any) {
						return '<div>' +
						(item.text ? '<span class = "airportname">' + escape(item.text.split('|')[0].split('__')[0]) + ',</span> ' + escape(item.text.split('|')[1]) +'<span class = "airportcode">'+ escape(item.text.split('|')[2])+'</span>': '') +
						'</div>';
					}
				}
			});
		});
		setTimeout(() => {
			this.$scope.find('input').attr("autocomplete", "new-password");
			this.$scopeMob.find('input').attr("autocomplete", "new-password");
		}, 1800);
	}
		cabinClass(): void {
		let _self = this;
		let $cabinClass = $('.cabin-class');
		let $cabinSelected:any = $cabinClass.selectize({
			onChange: () =>  {
				$cabinClass.find('.booking-form--title').addClass('input-filled');
				$cabinClass.find('.selectize-control.single .selectize-input').addClass('select-filled');
				$('.cabin-class').on('change', function() {
					if($('.ibe_freesidetrip').is(":visible")) 
					{
					$('.ibe_freesidetrip').hide();					
					$('.single-city--bookflight').show();
					}
				});
			}
		});
		}
	DesktopSiteTripButtonDisplay(tripType:any): void {
		let isSideTripEnabled =  $('#isSideTripEnable').val();
		let type = $('input[name="cash_miles_type"]:checked').val();
	if(type === 'cash') {
		if (isSideTripEnabled === 'Yes') {
		let _self = this;
		let curInstance = _self.$instance;
		let $FromLocation:any = curInstance.find('.ibe-from--location');
		let $ToLocation:any = curInstance.find('.ibe-to--location');
		let $passengerCnt:any = curInstance.find('input.total-tickets--value').val();
		let $cabinClass:any = curInstance.find('.cabin-class').val();
		let $CouponCode = curInstance.find('.couponcode-input').val();

		let $oneWayTripEl:any  = curInstance.find('.trip-type--container .oneWayTrip'),
		$oneWayDepDate:any = curInstance.find('.oneWayTrip .departureDate'),
		$returnDepDate:any = curInstance.find('.departureDate'),
		$returnRetDate:any = curInstance.find('.returnDate');
		let $formDataValid:any = true;
		let $formOneway:Boolean = false;

		if(tripType == ''){
			if ($oneWayTripEl.hasClass('selected')) {
				$formOneway = true;
			}
		}else{
			if(tripType == 'oneWay'){
				$formOneway = true;
			}
		}
		if ($formOneway === true) {
			if ($oneWayDepDate.val() == '') {
				$formDataValid= false;
			}
		}else{
			if ($returnDepDate.val() == '' || $returnRetDate.val() == ''){
				$formDataValid= false;
			}
		}
		if ($FromLocation.val() != '' && $ToLocation.val()!=='' && $passengerCnt != 0 && $cabinClass != '' && $CouponCode =='' && $formDataValid == true ){
			if (_self.bookingFormSubmit.DesktopSidetripEligibilityCheck(curInstance)) {
				curInstance.find('.ibe_freesidetrip').show();
				curInstance.find('.single-city--bookflight').hide();
				
			}
		}
		}
	}
	}
	/**
	 * [multiCleanDestData description]
	 * Re-arrange and shift up the destination params to ensure they are listed as how
	 * the user wants them to ensure no empty fields between filled destinations.
	 *
	 * ie. user fills in row 1 - row 4 and deletes row 3 before submission.
	 * final serialized form contains:
	 * row 1: data
	 * row 2: data
	 * row 3: empty
	 * row 4: data
	 *
	 * re-arrange dataset so data is pushed upwards:
	 *
	 * row 1: data
	 * row 2: data
	 * row 3: data
	 * row 4: empty
	 * @param  {[type]} formObj [description]
	 * @return {[obj]} cleanedFormOPb [description]
	 * !!! Properly scoped
	 */

	multiCleanDestData(formObj:any):any {
		let i:number = 1;
		let tempId:number = 1;
		let cleanedDestObj:any = {};

		// loop through all destination input data
		// if data is valid, add to temp object (with its own id range),
		// else disregard
		// increment temp object id only if data is valid and added
		while (i < 7) {
			// if form row data exists
			if (formObj["multiCityfromLocation"+ i] && formObj["multiCityfromLocation"+ i] && formObj["multiCityDepartureDate"+ i]) {
				// clone row data into temp object
				cleanedDestObj["B_LOCATION_"+ tempId] = formObj["multiCityfromLocation"+ i];
				cleanedDestObj["E_LOCATION_"+ tempId] = formObj["multiCitytoLocation"+ i];
				cleanedDestObj["B_DATE_"+ tempId]     = formObj["multiCityDepartureDate"+ i];

				tempId++;
			}

			// reset row data in form object (irregardless filled or not)
			formObj["B_LOCATION_"+ i] = undefined;
			formObj["E_LOCATION_"+ i] = undefined;
			formObj["B_DATE_"+ i]     = "";

			i++;
		}

		// replace form data with new cleaned data values
		let destVars:any = Object.keys(cleanedDestObj);

		destVars.forEach(function(destVar:any) {
			formObj[destVar] = cleanedDestObj[destVar];
		});

		return formObj;
	}

	/**
	 * Init add remove buttons for multicity ibe form
	 * @return {any} [description]
	 * !!! Global
	 */
	initMultiCityAddRemoveBtns():void {
		let _self = this;

		let addFlightBtn:any = _self.$instance.find('.multi-cityTrip--Container .addAnotherFlight');
		let removeBtn:any = _self.$instance.find('.multi-cityTrip--Container .multi-city--destination-group .remove-flight a');
		let curInstance = _self.$instance; // assign current instance to var as later requests will call latest assigned instance

		// debug only
		var multicitylink = _self.$instance.find('a[data-omni="ibe_bookflight_multicity"]');
		// debug only

		// display new flight items
		addFlightBtn.on('click', function(e:any) {
			e.preventDefault();
			let hiddenDests:any = curInstance.find('.multi-cityTrip--Container .multi-city--destination-group.multi-city--hide');
			if (hiddenDests.length) {
				let firstDestHidden:any = hiddenDests[0];
				// show first instance of hidden destination field.
				// if all fields are shown, fade out and "disable the button"
				$(firstDestHidden).removeClass('multi-city--hide');
				firstDestHidden.dataset.flightEnabled = 1;
				let remainingFlightsAllowed:number = hiddenDests.length - 1;
				if (!remainingFlightsAllowed) {
					$(this).css({
						'opacity': 0.35,
						'cursor': 'not-allowed'
					});
				}
			}
			return;
		});

		// hide flight item
		removeBtn.on('click', function(e:any) {
			e.preventDefault();
			let destToHide:any = $(this).parents().eq(1);
			destToHide.addClass('multi-city--hide');
			destToHide[0].dataset.flightEnabled = 0;

			// get id value from flight fieldset
			let destId = destToHide[0].dataset.flightNo;
			destId--;

			let $errorValidation:any = curInstance.find('.error-validation'),
				errObj:any = {
						errFromLi   : $errorValidation.find('span[data-error="emptyFlightFrom'+destId+'"]'),
						errToLi     : $errorValidation.find('span[data-error="emptyFlightTo'+destId+'"]'),
						errDepLi    : $errorValidation.find('span[data-error="duplicateFlightDestinations'+destId+'"]'),
						errDupLi    : $errorValidation.find('span[data-error="emptyDepartureDate'+destId+'"]'),
						errPrevFlLi : $errorValidation.find('span[data-error="prevFlightMoreCurrFlight'+destId+'"]')
				};

			// remove error messages if exist for each error item
			$.each(errObj, function(key:string, value:any){
				$(this).fadeOut(300, function(){
					$(this).remove();
				});
			});

			let hiddenDests:any = curInstance.find('.multi-cityTrip--Container .multi-city--destination-group.multi-city--hide');

			// if able to add flights, re-enable the "add flights" button
			let remainingFlightsAllowed:number = hiddenDests.length;
			if (remainingFlightsAllowed) {
				addFlightBtn.css({
					'opacity': '',
					'cursor': ''
				});
			}
		});
	}

	/**
	 * determine via parent container data-attribute if form is cug.
	 * if cug, hide payment and redemption login sections
	 */
	cugForm(): void {
		let _self = this;

		let cugCondition = _self.$instance.attr('data-cug') === 'true';

		if (cugCondition) {
			//_self.$instance.addClass('cug');
			_self.$instance.find('.payment-type-container').hide().addClass('hidden');
			_self.$instance.find('.container--redemption-login').hide().addClass('hidden');
			//_self.$instance.find('.couponCode').hide();
		} else {
			// remove cug hidden input
			_self.$instance.find('input[name="param_cug"]').remove();
		}

	}


	/**
	 * pre-populate ibe on load with data attached via data-attributes
	 * only for DESKTOP ibe
	 * @author dominic <dominic.gan@mirumagency.com>
	 *
	 * 2018/03/20 update:
	 * - extend method to accept params (data,instance) to manually invoke and
	 *   populate topnav ibe for deep link
	 */
	populateOnload(data?:ibeTripData, instance?:any): void {
		let _self = this;
		let tripData:ibeTripData = {};

		// use current instance and dataset of instance if not passed into method
		if (instance === undefined) {
			instance = _self.$instance;
		}

		if (data === undefined) {
			tripData = _self.$instance.data();

			// cast date params as string
			if (tripData.fromDate) {
				tripData.fromDate = tripData.fromDate.toString();
			}
			if (tripData.toDate) {
				tripData.toDate = tripData.toDate.toString();
			}
		} else {
			tripData = data;
		}

		// trip type (set first as current behavior wipes input fields after change)
		// use promise to determine completion before setting other fields
		let tripTypeSet = $.Deferred();

		switch (tripData.triptype) {
			case 'R':
			case 'return':
				instance.find('.trip-type--container .returnTrip').trigger('click.triptype', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'O':
			case 'oneway':
				instance.find('.trip-type--container .oneWayTrip').trigger('click.triptype', tripTypeSet.resolve(tripData.triptype));
				break;
			case 'M':
			case 'multicity':
				instance.find('.trip-type--container .multiCityTrip').trigger('click.triptype', tripTypeSet.resolve(tripData.triptype));
				break;
			default:
				tripTypeSet.resolve('R'); // retain default (return) and resolve promise
				break;
		}

		tripTypeSet.promise();

		$.when(tripTypeSet).done((triptype:string) => {
			// payment type (set before OnD) 
			// if multicity flow is set, don't change payment type to miles
			let $paymentTypeInput = instance.find('.payment-method-options');
			switch (tripData.paymentType) {
				case 'C':
				case 'cash':
					$paymentTypeInput.find('input[name="cash_miles_type"][value="cash"]').prop('checked', true).click();
					break;
				case 'M':
				case 'miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="miles"]').prop('checked', true).click();
					}
					break;
				case 'CM':
				case 'cash_miles':
					if (triptype !== 'M') {
						$paymentTypeInput.find('input[name="cash_miles_type"][value="cash_miles"]').prop('checked', true).click();
					}
					break;
				default:
					break;
			}

			// ond fields
			switch (triptype) {
				case 'R':
				case 'return':
				case 'O':
				case 'oneway':
					// assign "to location" value to prepop into class variable
					// (to await completion of updating "from location")
					// following which the "to location" value will be populated
					if (tripData.toLoc !== undefined) {
						_self.toPrepop = tripData.toLoc;
					}

					// from location (selectize instance)
					if (tripData.fromLoc !== undefined) {
						let $fromLocationInput = instance.find('select.ibe-from--location')[0].selectize;
						$fromLocationInput.setValue(tripData.fromLoc);
					}
					break;
				case 'M':
				case 'multicity':
					let $mcFromLocationInput = instance.find('select.multicity-from--location');

					// assumes ond values are provided as comma separated string
					// ie. KUL,SIN,PEN,HKG
					// split and store as array for applying into multicty ond fields
					let $mcFromDataArr = tripData.fromLoc.split(',');
					let $mcToDataArr = tripData.toLoc.split(',');

					$mcFromLocationInput.each((i:number, el:any) => {
						// assign "to location" value to prepop into class variable
						// (to await completion of updating "from location")
						// following which the "to location" value will be populated
						_self.toPrepop = $mcToDataArr[i];
						el.selectize.setValue($mcFromDataArr[i]);
					});
					break;
				default:
					break;
			}

			// passengers input
			// populate values into input fields and trigger change to update displayed total value
			// adult
			if (tripData.psgAdult !== undefined) {
				let $psgAdultInput = instance.find('.minus-plus-input.passengersAdult');
				$psgAdultInput.val(parseInt(tripData.psgAdult)).trigger('change');
			}

			// child
			if (tripData.psgChild !== undefined) {
				let $psgChildInput = instance.find('.minus-plus-input.passengersChildren');
				$psgChildInput.val(parseInt(tripData.psgChild)).trigger('change');
			}

			// infant
			if (tripData.psgInfant !== undefined) {
				let $psgInfantInput = instance.find('.minus-plus-input.passengersInfant');
				$psgInfantInput.val(parseInt(tripData.psgInfant)).trigger('change');
			}

			/**
			 * test validity of date value for single trip
			 * criteria:
			 * - not undefined
			 * - string length > 0
			 * - string does not contain commas (multicity)
			 * @param {string} testString
			 */
			let validSingleDate = function (testString:string) {
				return (testString !== undefined && testString.length > 0 && testString.indexOf(',') < 0);
			};

			// travel dates (set last, should only happen after trip type has been set)
			// set date and trigger blur to set input field focus state
			// if trip type is return/oneway, don't populate datefields if multicity format is detected (comma present)
			switch (triptype) {
				case 'R':
				case 'return':
					// from date
					if (validSingleDate(tripData.fromDate)) {
						let $fromDateInput = instance.find('.returnTrip .departureDate');
						$fromDateInput.datepicker('setDate', moment(tripData.fromDate, 'YYYYMMDD').toDate()).trigger('blur', 'input');
					}
					// to date
					if (validSingleDate(tripData.toDate)) {
						let $toDateInput = instance.find('.returnTrip .returnDate');
						$toDateInput.datepicker('setDate', moment(tripData.toDate, 'YYYYMMDD').toDate()).trigger('blur', 'input');
					}
					break;

				case 'O':
				case 'oneway':
					// oneway from date
					if (validSingleDate(tripData.fromDate)) {
						let $owFromDateInput = instance.find('.oneWayTrip .departureDate');
						$owFromDateInput.datepicker('setDate', moment(tripData.fromDate, 'YYYYMMDD').toDate()).trigger('blur', 'input');
					}
					break;

				case 'M':
				case 'multicity':
					let $mcFromDateInput = instance.find('.multi-city--destination-group .dateDeparture');
					// assumes dep date values are provided as comma separated string
					// ie. 20180410,20180411,20180412

					let $mcFromDateArr = tripData.fromDate.split(',');
					let $mcAddFlightBtn = instance.find('.addAnotherFlight');
					$mcFromDateInput.each((i:number, el:any) => {
						// if more than 2 trips for multicity, trigger click on add flight button to display new ond option
						if (i > 1 && $mcFromDateArr[i]) {
							$mcAddFlightBtn.click();
						}
						if ($mcFromDateArr[i] !== undefined && $mcFromDateArr[i].toString().length > 0) {
							$(el).datepicker('setDate', moment($mcFromDateArr[i], 'YYYYMMDD').toDate()).trigger('blur', 'input');
						}
					});
					break;
			}

			// cabin class
			let $cabinClassInput = instance.find('select.cabin-class')[0].selectize;
  		switch (tripData.cabinType) {
  			case 'F':
  			case 'CFFFIRST':
  				$cabinClassInput.setValue('CFFFIRST');
	  			break;
  			case 'B':
  			case 'CFFBUS':
  				$cabinClassInput.setValue('CFFBUS');
	  			break;
  			case 'E':
  			case 'CFFECO':
  				$cabinClassInput.setValue('CFFECO');
	  			break;
	  		default:
	  			break;
  		}

  		// coupon code
  		let $couponCodeInput = instance.find('.couponcode-input');
  		if (tripData.couponCode !== undefined) {
  			$couponCodeInput.val(tripData.couponCode).trigger('blur');
  		}
		});
	}

	/**
	 * fill prepop value to this select if waiting prepop value is present
	 */
	fillToPrepopValue(el:any):void {
		let _self = this;
		let val = _self.toPrepop;

		if (val) {
			el.setValue(val);
			_self.toPrepop = null;
			_self.isIbePrepop = true;
		}
	}

	/**
	 * parse url params to detect book flight deep link
	 * open and populate with params
	 * ?ibe=bfl&fromLoc=ABC&toLoc=ABC&triptype=ABC&fromDate=ABC&toDate=ABC&paymentType=ABC&cabinType=ABC&psgAdult=ABC&psgChild=ABC&psgInfant=ABC&couponCode=ABC
	 */
	deeplink():void {
		let _self = this;
		let bcommon = _self.bcommon;

		let urlParams = bcommon.getUrlVars(window.location.href);
		const topNavIbe = $('.desktop#mab-bookingnav [data-ibe--book-flight]');

		if (urlParams.ibe && urlParams.ibe === 'bfl') {

			// parse url params into tripdata object
			let tripData:ibeTripData = {};

			tripData.fromLoc = urlParams.fromLoc;
			tripData.toLoc = urlParams.toLoc;
			tripData.triptype = urlParams.tripType;
			tripData.fromDate = urlParams.fromDate ? urlParams.fromDate.toString() : urlParams.fromDate;
			tripData.toDate = urlParams.toDate ? urlParams.toDate.toString() : urlParams.toDate;
			tripData.paymentType = urlParams.paymentType;
			tripData.cabinType = urlParams.cabinType;
			tripData.psgAdult = urlParams.psgAdult;
			tripData.psgChild = urlParams.psgChild;
			tripData.psgInfant = urlParams.psgInfant;
			tripData.couponCode = urlParams.couponCode;

			// pass tripData object and instance into populateData method
			
			// expand desktop ibe
			if (!(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
				let $ibeNav:any = $('#bookingNav');
				$ibeNav.find('.book-flight').parent().addClass('selected');

				topNavIbe.show();
				_self.expandIbe(topNavIbe);
			}

			_self.populateOnload(tripData, topNavIbe);
		}

		else if (urlParams.paymentType && (urlParams.paymentType=="cash_miles"))
		{

			setTimeout(function() {
				topNavIbe.show();
				_self.expandIbe(topNavIbe);
				$('input[value="cash_miles"]').prop("checked", true).trigger("click");
			}, 2000);
	
	
		} else if (urlParams.paymentType && (urlParams.paymentType=="miles")){
			setTimeout(function() {
				topNavIbe.show();
				_self.expandIbe(topNavIbe);
				if ($('.enrich-revamp').length > 0) {
					$('.enrich-revamp .redeem-flight').trigger("click");
				}
				$('input[value="miles"]').prop("checked", true).trigger("click");
				if(urlParams.populateRedeemFlight && (urlParams.populateRedeemFlight == "true")) {
					let tripData:ibeTripData = {};
					tripData.fromLoc = urlParams.fromLoc;
					tripData.toLoc = urlParams.toLoc;
					_self.populateOnload(tripData, topNavIbe);
				}				
			}, 2000);

		}
		
	}
	checkAvailablityEnrichAlways():boolean{
		let _self=this;
		let rtnVal: boolean=_self.isValidFromLocation && _self.isInAllowedListEnrichOnFrom && _self.isValidToLocation;
		if(rtnVal){
			$(".enrichOnDiscountToggleContainer").removeClass('hideclass');
			$(".enrichOnDiscountInformation").addClass('hideclass');
		
		}
		else{
			$(".enrichOnDiscountToggleContainer").addClass('hideclass');
			$(".enrichOnDiscountInformation").addClass('hideclass');
		}
		return rtnVal;
	}

	ONDenrichFromLocation(seletedItem:any){
		let _self=this;
		if (seletedItem) {
		
			const seletedOptGroup:string = seletedItem.optgroup;
			if(( seletedOptGroup == "With Malaysia Airlines" || seletedOptGroup == "online")){
				const selectedCountry:string = seletedItem.text.split('|')[1];
				if(_self.enrichAlwaysOnCountriesData.includes(selectedCountry)){
					_self.isValidFromLocation=true
					_self.isInAllowedListEnrichOnFrom = true;
					_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
					return;
				}
			}
			else if(seletedOptGroup == "Recent Searches" || seletedOptGroup == "recent-search"){
	
				const isEnrichAlawaysOn:string = seletedItem.text.split('|')[18];
				if(isEnrichAlawaysOn=='EAON'){
				_self.isValidFromLocation=true
				_self.isInAllowedListEnrichOnFrom = true;
				_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
				return;
				}
			}
		}
		_self.isValidFromLocation=false;
		_self.isInAllowedListEnrichOnFrom=false;
   
		_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
		
	}

	
	ONDenrichToLocation(seletedItem:any):void{
		let _self=this;
		if (seletedItem) {
			const seletedOptGroup:string = seletedItem.optgroup;
			if( seletedOptGroup == "With Malaysia Airlines" || seletedOptGroup == "online") {
				_self.isValidToLocation=true;
				_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();		
				return;
			}
			else if(seletedOptGroup == "Recent Searches" || seletedOptGroup == "recent-search"){
					_self.isValidToLocation=true;
					_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();
					return;
			}
		}
		_self.isValidToLocation=false;
		_self.isEligibleEnrichAlwaysOn= _self.checkAvailablityEnrichAlways();


	}
}

let scope:any = document.querySelector('[data-ibe--book-flight]');
let scopeMob: any = document.querySelector('#mobile-bookflight--container'); // mobile ibe
let scopeGroupTravel: any = document.querySelector('#group-booking--trip');
let standAloneIBE: any = document.querySelector('#ibe-standalone-camp');
let standAloneIBEFrame: any = document.querySelector('#ibe-standalone-iframe');

let bookingformcommon = new bookingFormCommon();
if (scope || scopeMob || scopeGroupTravel) {
	bookingformcommon.inputFormFocus();
	bookingformcommon.formFieldValidator();
	bookingformcommon.cabinClass();
  bookingformcommon.datePickerAfterShowEvent();
}

window['ibeOnDList'] = $.Deferred();

bookingformcommon.airportlist().done((listData: any) => {
	window['ibeOnDList'].resolve(listData);
});

window['ibeOnDList'].promise();

window['ibeOnDListNew'] = $.Deferred();

bookingformcommon.airportlistNew().done((listData: any) => {
	window['ibeOnDListNew'].resolve(listData);
}).fail((error:any) => {
	if (($('#ibe-standalone-travelpass').length) > 0) {
		$('#ibe-standalone-travelpass').hide();
		$.magnificPopup.open({
            items: {
                src: '#flypass--error-popup'
            },
            type: 'inline',
            midClick: true,
            enableEscapeKey: false,
            showCloseBtn: false,
            closeOnBgClick: false,
            modal: true,
            callbacks: {
                open: function() {
                    var $content = $(this.content);
     
                    $content.on('click', '.flypass-msg-btn-refresh', function() {
                        $.magnificPopup.close();                        
						location.reload();
                    });   
                }
            }
        }, 0);
	}
});

window['ibeOnDListNew'].promise();
// window['ibeOnDListMulticity'] = $.Deferred();

// bookingformcommon.airportlistMulticity().done((listData: any) => {
// 	window['ibeOnDListMulticity'].resolve(listData);
// })

// window['ibeOnDListMulticity'].promise();

if (scope){
	try {
		let bookflight = new bookingFormContent();
		let bookflightredemption = new bookingFormRedemption();
		let bookflightinfant = new bookingFormInfant();
		let bookingformsideTrip = new bookingFormSideTrip();
		var adobeDataLayer = new adobeDataLayerWrapper();
		// start: init navbar behavior
		bookflight.nav();
		bookflight.init();
		bookflight.closeIbeHandler();
		// end: init navbar behavior
		$('.ibe_freesidetrip').hide();
		// all these methods should be scoped

		// desktop ibe
		let desktopIBEs:any = document.querySelectorAll('[data-ibe--book-flight]');
		let numDesktopIBEs:number = desktopIBEs.length - 1;
		let lastOnDDone:any = $.Deferred();
		let topNavIbe: any = $('.desktop#mab-bookingnav [data-ibe--book-flight]');

		$.when(window['ibeOnDListNew']).done((listData: any) => {
			Array.prototype.map.call(desktopIBEs, function(instance:any, i:number) {
				bookflight.setInstance(instance);
				bookflight.createDesktopErrorValidationList();
				bookflight.ibeSingleFormSubmitHandler();
				bookflight.ibeMultiFormSubmitHandler();
				bookflight.getOfficeCode();
				bookflight.displayRecentSearch();
				bookflight.recentSearch();
				bookflight.ibeTripType();
				bookflight.calendarComponent();
				bookflight.passengerDetails();
				bookflight.passengerType();
				bookflight.initMultiCityAddRemoveBtns();
				bookingformsideTrip.init($('.ibe-freesidetrip_deskp'));
				bookingformsideTrip.ibeTripType(instance);
				bookingformsideTrip.calendarComponent($('.ibe-freesidetrip_deskp'));
				bookingformsideTrip.calendarComponentSideTrip($('.ibe-freesidetrip_deskp'));
				bookingformsideTrip.passengerTypeSideTrip($('.ibe-freesidetrip_deskp'));
				bookingformsideTrip.passengerDetailsSideTrip($('.ibe-freesidetrip_deskp'));	
				console.log('%cc005book%c ond done', 'background-color: yellow', 'background-color: initial');			
				// onload use revenue OnD data
				let listItems: string;
				listItems = bookingformcommon.parseOnDListItemsNew(listData, 'revenue', 'From');
				let listItemsMulticity = bookingformcommon.parseOnDListItemsNew(listData, 'multicity', 'From');
				let studentEnrichIdCookieVal = document.cookie.match('(^|;)\\s*studentEnrichId\\s*=\\s*([^;]+)');
				let studentDashboard = document.querySelector('.student-dashboard');
				if (studentEnrichIdCookieVal != null && studentDashboard != null) {
					listItems = bookingformcommon.parseOnDListItemsNew(listData, 'redemption', 'From');
				}
				let listToItems: string;

				listToItems = bookingformcommon.parseOnDListItemsNew(listData, 'revenue', 'To');
											
				if (studentEnrichIdCookieVal != null && studentDashboard != null) {
					listToItems = bookingformcommon.parseOnDListItemsNew(listData, 'redemption', 'To');
				}
				bookingformsideTrip.initSelectize(listItems, instance);
				bookingformsideTrip.initSelectizeIbeSideTrip(listItems, instance);
				bookingformsideTrip.sidetripLocationSubmit($('.ibe-freesidetrip_deskp'));
				bookingformsideTrip.desktopsidetip(instance);
				bookingformsideTrip.optforsidetripoffer($('.ibe-freesidetrip_deskp'), bookflight.getOfficeCode());			
				bookflight.initSelectize(listItems, listToItems,listItemsMulticity);								
				bookflightinfant.toggleSubmitBtnDisplay(instance);
				bookflightredemption.initPaymentMethods($(instance));
				bookflightredemption.initRdmLogin($(instance), '.single-city--bookflight', '.multi-city--bookflight', '.ibe-from--location', '.ibe-to--location');
				bookflight.cugForm();
                bookflight.swapFromToLocation();
				bookflight.populateOnload();
				if (numDesktopIBEs == i) {
					lastOnDDone.resolve();
				}
			});
		});
		
		
		lastOnDDone.promise();

		$.when(lastOnDDone).done(() => {
			bookflight.deeplink();
		});
		
		bookflightinfant.closeBtns();
		if ($('.ibe-refresh').length > 0) {
			bookflight.expandIbe(topNavIbe);
		}
	} catch(e) {console.error(e);}
}
